export const faMessages = {
  undefined: "تعریف نشده",
  moneyUnit: "ریال",
  millimeter: "mm",
  millionMoneyUnit: "میلیون ریال",
  pleaseWait: "لطفا چند لحظه صبر کنید",
  pleaseWaitDesignMode: "در حال ذخیره سازی یونیت، لطفا چند لحظه صبر کنید",
  suggestionPrice: "قیمت پیشنهادی",
  typeNumberError: "فقط عدد صحیح مجاز می باشد",
  wrongPercentage: "درصد اشتباه می‌باشد",
  correctFormDataRequired: "لطفا اطلاعات را به درستی وارد کنید",
  all: "همه",
  searchGlassProName: "جستجو نام محصول شیشه",
  selectYaraghBrand: "لطفا برند یراق را انتخاب کنید",
  minBTmax: "مقدار برای حداقل باید کمتر از حداکثر باشد",
  noData2Display: "اطلاعاتی برای نمایش وجود ندارد",
  method: "روش",
  coverage: "پوشش",
  sizeMM: "سایز (میلیمتر)",
  width: "± عرض لنگه",
  height: "± ارتفاع لنگه",
  MovableInc: "کسری متحرک",
  MovableCount: "تعداد متحرک",
  widthRange: "محدوده عرض",
  heightRange: "محدوده ارتفاع",
  selectedProject: "پروژه انتخاب شده",
  selectProject: "انتخاب پروژه",
  home: "خانه",
  exit: "خروج",
  createdByUser: "ثبت شده توسط کاربر",
  createdByAdmin: "ثبت شده توسط ادمین",
  customer: "مشتری",
  date: "تاریخ",
  uploadLogo: "بارگذاری لوگو",
  uploadWaterMark: "بارگذاری سربرگ",
  ZehvarBaranTowRail: "جفت ریل",
  ZehvarBaranOneRail: "تک ریل",
  ZehvarBaranFixOneRail: "لنگه فیکس تک ریل",
  ZehvarBaranBottom: "جهت پایین",
  ZehvarBaranAll: "همه جهت ها",
  Image: "تصویر",
  Structure: "ساختار",
  Select_the_unit: "انتخاب یونیت",
  ProfileStructure: "ساختار پروفیل",
  MeterLong: "متر طول",
  Weighty: "وزنی",
  FinalPrice: "قیمت نهایی",
  Invoice_preview_v2: "پیش نمایش",
  Invoice_price_calculation: "محاسبه قیمت فاکتور",
  Invoice_preview: "پیش نمایش فاکتور",
  Invoice_saved_successfully: "فاکتور با موفقیت ذخیره شد",
  Please_select_the_desired_unit: "لطفا یونیت مورد نظر را انتخاب کنید",
  Profile_charge_manually: "شارژ پروفیل به صورت دستی",
  Calculation_of_the_profile_value_based_on_the_number_of_branches_optimization:
    "محاسبه مقدار پروفیل بر اساس تعداد شاخه (بهینه سازی)",
  Calculation_of_waste_profile_and_adding_to_the_amount_of_profile:
    "محاسبه ضایعات پروفیل و اضافه نمودن به مقدار پروفیل",
  percent: "درصد",
  IsCalcPriceUnit: "اعمال بر قیمت پایه",
  IsWaterMark: "دارای سربرگ می باشد",
  IsIncOtherProfileToMetrajhUnitBUnit:
    "پروفیل‌های متفرقه در متراژ مصرفی لحاظ شوند",
  Select_price_from_archived_invoice: "انتخاب قیمت از فاکتور آرشیو شده",
  admin: "ادمین",
  user: "کاربر",
  contract_amount_problem:
    "مبلغ قرارداد با مجموع ملبغ های ثبت شده یکسان نمی باشد",
  successfully_registered_contract: "قرارداد با موفقیت ثبت گردید",
  number: "شماره",
  archive: "آرشیو",
  new_receipt_register: "ثبت دریافتی جدید",
  select_invoice: "انتخاب فاکتور",
  total_received: "مجموع دریافتی",
  remaining: "باقیمانده",
  byCash: "نقدی",
  byCheck: "چکی",
  view_payments: "مشاهده پرداختی ها",
  Nothing_found: "موردی یافت نشد",
  glass_excel_file: "فایل اکسل شیشه",
  graphically: "به صورت گرافیکی",
  linearly: "به صورت خطی",
  stickerly: "به صورت برچسب",
  excely: "خروجی اکسل",
  hinged: "لولایی",
  sliding: "کشویی",
  combinatory: "ترکیبی",
  unit_information: "اطلاعات یونیت",
  design_setting_done: "تنظیمات طراحی با موفقیت انجام شد",
  invoice_number: "شماره فاکتور",
  unit_space: "مساحت یونیت",
  admin_price: "مبلغ ادمین",
  user_price: "مبلغ کاربر",
  financial_group_price: "مبلغ گروه مالی",
  contracted: "قرارداد شده",
  calculate_pr_lo: "سود / زیان",
  NameGroup: "نام گروه",
  multiply: "برابر",
  increase: "افزایش",
  decrease: "کاهش",
  relationAlert:
    "آیتم های دیگری به آیتم انتخاب شده وابسته هستند، لطفا وابستگی ها را برطرف کنید",
  fixer: "فیکسر",
  lastik: "لاستیک",
  upvc: "UPVC",
  alu: "آلومینیوم",
  dual_mode: "دو حالته",
  single_mode: "تک حالته",
  normal_mode: "معمولی",
  window: "پنجره",
  door: "در",
  foam: "فوم",
  mastic: "ماستیک",
  bank_portal: "درگاه بانکی",
  bank_portal_updating: "درگاه بانکی (در حال بروزرسانی)",
  financial_group: "گروه مالی",
  EnterMobileNumber: "لطفا شماره تماس خود را وارد کنید",
  checkAllFields: "لطفا تمامی فیلدها را بررسی کنید",
  invalidNumber: "شماره همراه نامعتبر می باشد",
  mobileExample: "مثال: ۰۹۱۲۱۲۳۴۵۶۷",
  invalidInformation: "لطفا اطلاعات را به درستی وارد کنید",
  enterInformationCorrectly:
    "لطفا اطلاعات درخواستی زیر را به صورت صحیح وارد نمایید",
  enterNewPassword: "لطفا رمز عبور جدید را وارد کنید",
  fromDate: "از تاریخ",
  toDate: "تا تاریخ",
  peroidDetails: "جزئیات دوره",
  undefinedError: "خطا نامشخص رخ داده است، با پشتیبانی تماس حاصل فرمایید",
  getDataError: "خطا در گرفتن اطلاعات، لطفا مجدد تلاش کنید",
  yes: "بله",
  addNewUnit: "یونیت جدید",
  addNewSquareUnit: "مستطیلی",
  addNewNoSquareUnit: "متنوع",
  unitList: "لیست یونیت ها",
  unitList2: "یونیت‌های طراحی شده",
  backToPrj: "بازگشت به لیست پروژه ها",
  toolsSideDrawerWarning: "یونیت انتخاب نشده است",
  invalidAuthCode: "کد اعتبار سنجی را به درستی وارد کنید",
  enterCode: "کد ارسال شده از طریق پیامک را وارد کنید",
  fdpSupport: "ارتباط با ما",
  needSupport: "نیاز به مشاوره دارید؟",
  newCustomer: "ثبت مشتری جدید",
  repetitiveProject: "پروژه تکراری است",
  select_archived_invoice: "انتخاب فاکتور آرشیو",
  convertFromToWP: "تبدیل از (@P1) به (@P2)",
  emptyInSelect: "-- خالی --",
  totalPrice: "قیمت کل",
  unitsNumber_renovation_reconstruction:
    "تعداد یونیت بر اساس فریم نوسازی و بازسازی",
  removed_successfully: "با موفقیت حذف گردید",
  requestedUsersNumberProblem:
    "تعداد کاربران درخواستی با کاربران موجود در پنل مدیریت باید یکسان یا اضافه تر باشد",
  pnlChart: "نمودار محاسبه سود و زیان پروژه",
  financial_group_admin: "گروه مالی کاربر (ادمین)",
  lockedProject: "پروژه در وضعیت قفل می باشد",
  doorWindowCount: "تعداد در و پنجره",
  openerSystemiCount: "تعداد بازشو سیستمی",
  openerCount: "تعداد بازشو",
  glassesCount: "تعداد شیشه",
  glassSpace: "مساحت شیشه",
  netCount: "تعداد توری",
  netSpace: "مساحت توری",
  optimizedProfileBranchMeteringChart:
    "نمودار متراژ بهینه سازی شده شاخه های پروفیل",
  optimizedProfileSideWasteAreaDiagram:
    "نمودار متراژ بهینه سازی شده پروفیل و کناره و ضایعات",
  projectsCount_province: "تعداد پروژه بر اساس استان",
  projectsCount_status: "تعداد پروژه بر اساس وضعیت",
  unitsCount_hingePattern: "نمودار تعداد یونیت بر اساس الگوی لولایی",
  unitsCount_rayleighPattern: "نمودار تعداد یونیت بر اساس الگوی ریلی",
  unitsCount_frameStructure: "نمودار تعداد یونیت بر اساس ساختار فریم",
  dunitsCount_renovationReconstructionFrame:
    "نمودار تعداد یونیت بر اساس فریم نوسازی و بازسازی",
  onReplySMS: "پاسخ پیامک شود",
  newTicket: "تیکت جدید",
  createNewTicket: "ایجاد تیکت جدید",
  ticketSubset: "زیر مجموعه",
  ticketDetails: "جزئیات تیکت",
  fileDownload: "دانلود فایل",
  saveNewMessage: "پیام خود را بنویسید ...",
  successfullyUserInformationDeleted: "اطلاعات کاربر با موفقیت حذف گردید",
  sureForDeleteUserInfoWP:
    "آیا اطمینان به حذف تمامی اطلاعات کاربر انتخاب شده (@P1) را دارید؟",
  select: "انتخاب",
  selected: "انتخاب شده",
  setAccessLevel: "تنظیم سطح دسترسی ها",
  selectAll: "انتخاب همه",
  clickToSelectAll: "انتخاب همه موارد",
  sizeLimitWP: "سایز باید کمتر از [@P1 کیلوبایت] باشد",
  btnCheckCode: "بررسی کد",
  customPay: "پرداخت با مبلغ دلخواه",
  customPayPrice: "مبلغ دلخواه",
  selectedDate: "تاریخ انتخاب شده قبلی : ",
  SaveUnitSuccessfully: "ذخیره یونیت با موفقیت انجام گردید",
  successfullyEqualGlassOperation: "عملیات شیشه مساوی با موفقیت انجام شد",
  successfullyPanelCompletion: "کامل سازی پنل با موفقیت انجام شد",
  SlidingToHinge: "تبدیل فریم کشویی به لولایی",
  HingedToSliding: "تبدیل فریم لولایی به کشویی",
  disableGuideLines: "غیر فعال کردن خطوط راهنما(هنگام استفاده از پروفیل کمکی)",
  enableGuideLines: "فعال کردن خطوط راهنما(هنگام استفاده از پروفیل کمکی)",
  basedOnUserOffers: "بسته‌های پیشنهادی خرید اشتراک",
  buyAccount: "خرید اشتراک",
  basedOnUserOffersInfo:
    "می‌توانید تعداد کاربران یا مدت زمان اشتراک را متناسب با نیاز خود تنظیم کنید.",
  typePriceCalculation: "نوع محاسبه قیمت",
  screenSizeError_1:
    "صفحه نمایش فعلی شما برای کار با برنامه وب وین به علت گستردگی اطلاعات و گزینه ها کوچک می باشد. لازم است ادامه مسیر را بر روی صفحه نمایش بزرگتری انجام دهید",
  screenSizeError_2:
    "منتظر نسخه موبایل نرم افزار وب وین در آینده ای بسیار نزدیک باشید تا این مساله برای شما برطرف گردد",
  screenSizeError_3: "متشکریم",
  wasCopiedSuccessfully: "کپی یونیت مورد نظر با موفقیت انجام شد",
  copyUnit: "کپی یونیت",
  wasDeletedSuccessfully: "یونیت مورد نظر با موفقیت حذف شد",
  wasEditedSuccessfully: "یونیت مورد نظر با موفقیت ویرایش شد",
  editUnit: "ویرایش یونیت",
  FoamMasticUnit: "فوم و ماستیک یونیت",
  wasDoneSuccessfully: "فوم و ماستیک مورد نظر با موفقیت انجام شد",
  changeCustomerGroup: "تغییر گروه مشتریان",
  invoiceDescription: "شرح فاکتور",
  saveInvoiceDescription: "ثبت شرح فاکتور",
  chargeValue: "شارژ قیمت پایه",
  discountsValue: "مقادیر تخفیف",
  changeCustomerGroupInvoice:
    "با تغییر گروه مشتریان، مقادیر شارژ و تخفیف به صورت خودکار تغییر خواهند کرد",
  descriptionSavedSuccessfully: "شرح فاکتور با موفقیت ذخیره شد",
  noEditedItem: "موردی برای ویرایش وجود ندارد",
  newShisheGroup: "گروه‌بندی جدید",
  newShishe: "شیشه جدید",
  glassTbl: "محصولات شیشه",
  glassEdit: "ویرایش شیشه",
  newSpacer: "اسپیسر جدید",
  spacerTbl: "محصولات اسپیسر",
  spacerEdit: "ویرایش اسپیسر",
  customerGroupGetError: "گروه مشتریان به درستی دریافت نشده است",
  searchProfileCategory: "جستجو دسته پروفیل",
  searchProfileTypeColor: "جستجو نوع و رنگ پروفیل",
  searchBrandFitting: "جستجو برند یراق",
  searchPop: "جستجو بازشو",
  selectedSeriProfile: "سری پروفیل انتخاب شده",
  clickToAddProfile: "جهت اضافه کردن دسته پروفیل، روی یک سری پروفیل کلیک کنید",
  m2: "مترمربع",
  useSearchBtn: "برای جستجو از دکمه جستجو استفاده کنید",
  netIncWH: "افزایشی و کاهشی نسبت به لنگه",
  netMovable: "خصوصیت متحرک",
  invoiceTitle: "عنوان فاکتور",
  invoiceTitlePre: "پیش فاکتور",
  invoiceTitleMain: "فاکتور",
  unitSearch: "جستجو یونیت",
  needDescription: "لطفا برای فایل خود توضیحی بنویسید",
  sendMSG: "ارسال پیام",
  closedTicket:
    "این تیکت به دلیل اتمام پروسه بررسی بسته شده است، در صورت نیاز به پشتیبانی تیکت جدیدی ارسال کنید",
  closedTicketAdmin: "تیکت بسته شده",
  changeTicketToClose: "تغییر وضعیت به حالت بسته شده",
  changeTicketToChecking: "تغییر وضعیت به حالت درحال بررسی",
  preInvoiceTitle: "عنوان پیش فاکتور",
  identificationCode: "کد معرف",
  loadMore: "بارگذاری  ",
  loadUnitCount: "تعداد یونیت",
  loadUnitCountDetail: "@P1 از @P2",
  unitDetails: "مشخصات یونیت",
  _count: "عدد",
  factorPreventEntry_1: "شما به این بخش دسترسی ندارید",
  factorPreventEntry_2: "برای اطلاعات بیشتر با مدیر سیستم خود در ارتباط باشید",
  selectedUnitCount: "تعداد یونیت انتخاب شده",
  discountCharge: "تخفیف و افزایش قیمت پایه",
  factorDisplaySetting: "تنظیمات نحوه نمایش فاکتور",
  noWrite: "نوشته نشده",
  notCalculated: "محاسبه نشده",
  setSelected: "انتخاب کنید",
  projectsListMenu: "لیست پروژه‌ها",
  backMenu: "منو بازگشت",
  noSelectedProperties:
    "برای مشاهده مشخصات هر یک از اجزا، بخش مربوط به آن را انتخاب کنید",
  deleteUnit: "حذف یونیت",
  addButtonFastMode: "حالت سریع",
  addButtonNormalMode: "حالت عادی",
  unitShape: "شکل یونیت",
  unitWidth: "عرض یونیت",
  unitHeight: "ارتفاع یونیت",
  payment_reference_number: "شماره مرجع",
  payment_tracking_number: "شماره پیگیری",
  payment_error: "خطا در تراکنش بانکی",
  payment_problem: "کاربر گرامی، مشکلی در تکمیل سفارش رخ داده است",
  payment_tryAgain: "لطفا دقایقی دیگر مجددا تلاش کنید",
  payment_BackMobile: "بازگشت به برنامه موبایل",
  payment_choosing: "از اینکه ما را انتخاب کرده اید، متشکریم",
  payment_transferring: "در حال انتقال به درگاه بانکی ...",
  wrong_address:
    "آدرس وارد شده اشتباه است، لطفا با بخش پشتیبانی تماس حاصل فرمایید",
  supported_site: "در حال انتقال به سایت پشتیبانی",
  customer_registration: "ثبت مشتری",
  customer_registration_exp:
    "برای شروع کار با وب وین، ابتدا باید مشتری های خود را در سیستم وارد نمایید تا پس از آن برای هر کدام بتوانید پروژه ای تعریف کنید.",
  customer_registration_section: "ورود به بخش مشتریان",
  customer_project: "ثبت پروژه جدید",
  customer_project_exp:
    "پس از ثبت مشتری های خود، میتوانید برای هر یک پروژه ای تعریف کنید، مدیریت اطلاعات پروژه، طراحی، فاکتور، گزارش های ساخت، قرارداد و سود و زیان مربوط به پروژه در این بخش انجام خواهد گرفت.",
  customer_project_section: "ورود به پروژه‌ها",
  default_project_has_Another:
    "به لیست یونیت های پروژه پیش فرض پروژه دیگیری اضافه شده است",
  windWidthError: "مقدار عرض بادخور نباید در محدوده عرض یونیت باشد",
  windHeightError: "مقدار ارتفاع بادخور نباید در محدوده ارتفاع یونیت باشد",
  isPeriod: "پیش فرض",
  dimensionsError: "اندازه ابعاد صحیح نمی باشد",
  dimensionsLimitationError: "در نظر نگرفتن محدودیت فنی در ابعادگیری",
  patternNotSelected: "الگوی انتخاب نشده است",
  glassWallError: "جداره شیشه با زهوار یکسان نمی باشد",
  panelCompletion: "کامل سازی پانل",
  expiryCreditDate: "تاریخ پایان اعتبار",
  RemainingTime: "زمان باقی مانده اعتبار",
  month: "ماه",
  day: "روز",
  hour: "ساعت",
  minute: "دقیقه",
  haveDiscountCode: "آیا کد تخفیف دارید؟",
  enterDiscountCode: "کد تخفیف را وارد نمایید",
  priceCalculation: "محاسبه قیمت",
  viewDetails: "مشاهده جزئیات",
  periodDetails: "مشاهده جزئیات تمدید دوره",
  totalAmounts: "مجموع مبالغ",
  totalPayment: "مجموع پرداختی",
  totalTax: "مالیات بر‌ارزش‌افزوده",
  paymentCalcInfoPage:
    'برای مشاهده مجموع پرداختی، پس از تنظیم موارد انتخابی دکمه  "محاسبه قیمت"  را فشار دهید.',
  walletBalance: "موجودی کیف پول",
  activeUsersCount: "تعداد کاربر فعال",
  validityPeriod: "مدت اعتبار",
  currentPeriod: "دوره فعلی",
  paymentsHistory: "پرداخت ها و صدور فاکتور",
  periodName: "نام دوره",
  activeUsers: "تعداد کاربر فعال این دوره",
  transaction_error:
    "خطا در تراکنش بانکی! در صورتی که به صورت دستی تراکنش را لغو نکرده باشید مشکلی در تکمیل سفارش رخ داده است. لطفا دقایقی دیگر مجددا تلاش کنید. درصورت کسر وجه از حساب شما، مبلغ حداکثر تا 72 ساعت آینده عودت خواهد شد",
  successfulPayment: "پرداخت با موفقیت انجام شد",
  referenceNo: "شماره مرجع: ",
  issueTracking: "شماره پیگیری: ",
  increaseUserDetails: "مشاهده جزئیات افزایش کاربر",
  addUserCalculatedPrice:
    "مبلغ بدست آمده بر اساس زمان باقیمانده شما از سرویس فعلی به صورت لحظه ای حساب می شود",
  increaseWalletSuggestions: "بسته‌های ویژه",
  payableAmount: "مبلغ قابل پرداخت",
  receivedAmount: "میزان اعتبار دریافتی",
  expiredPanel: "اعتبار پنل شما به پایان رسیده است",
  contactSalesDepartment: "لطفا با بخش فروش تماس حاصل فرمائید",
  contactAdminDepartment: "لطفا با سرپرست سیستم خود تماس حاصل فرمائید",
  thanks: "با تشکر",
  purchaseDetails: "مشاهده جزئیات خرید",
  enter_username: "لطفا نام کاربری را وارد کنید",
  enter_password: "لطفا رمز عبور را وارد کنید",
  enter_amount: "لطفا مقدار را وارد کنید",
  enter_amount_WID: "لطفا @S1 را وارد کنید",
  not_contain_number_in_first: "عدد در ابتدای اسم مجاز نمی‌باشد",
  only_English_letters: "فقط حروف انگلیسی و اعداد مجاز می باشد",
  Error_amount_validation: "خطا در اعتبار سنجی مبلغ",
  not_zero: "لطفا عدد غیر از صفر وارد کنید",
  invalidEmail: "ایمیل معتبر نمی باشد",
  minimum_char_WID: "حداقل تعداد کاراکتر @S1 می باشد",
  maximum_char_WID: "حداکثر تعداد کاراکتر @S1 می باشد",
  minimum_value_WID: "حداقل مقدار @S1 می باشد",
  maximum_value_WID: "حداکثر مقدار @S1 می باشد",
  invalidMobile: "شماره موبایل نامعتبر است",
  minimum_decimal_WID: "تا @S1 رقم اعشار مورد قبول می باشد",
  invalidDecimalFormat: "فرمت عدد اعشاری صحیح نمی باشد",
  noDecimalAllowed: "عدد اعشاری مجاز نمی‌باشد",
  mission_accomplished: "عملیات با موفقیت انجام شد",
  changePriceSuccess: "قیمت با موفقیت ویرایش شد",
  The_editing_of_foam_and_mastic_was_done_successfully:
    "ویرایش فوم و ماستیک با موفقیت انجام گردید",
  The_new_foam_and_mastic_was_successfully_registered:
    "فوم و ماستیک جدید با موفقیت ثبت گردید",
  Foam_and_mastic_were_successfully_removed: "فوم و ماستیک با موفقیت حذف گردید",
  Successfully_added_spacer: "اسپیسر با موفقیت اضافه شد",
  Spacer_edited_successfully: "اسپیسر با موفقیت ویرایش گردید",
  The_spacer_was_successfully_removed: "اسپیسر با موفقیت حذف گردید",
  Glass_successfully_added: "شیشه با موفقیت اضافه شد",
  Glass_edited_successfully: "شیشه با موفقیت ویرایش گردید",
  The_glass_was_successfully_removed: "شیشه با موفقیت حذف گردید",
  Glass_group_added_successfully: "گروه شیشه با موفقیت اضافه شد",
  Glass_group_edited_successfully: "گروه شیشه با موفقیت ویرایش گردید",
  Glass_group_was_successfully_removed: "گروه شیشه با موفقیت حذف گردید",
  Glass_product_added_successfully: "محصول شیشه با موفقیت اضافه شد",
  The_glass_product_was_edited_successfully: "محصول شیشه با موفقیت ویرایش شد",
  The_glass_product_was_successfully_removed: "محصول شیشه با موفقیت حذف گردید",
  The_net_price_was_successfully_edited: "قیمت توری با موفقیت ویرایش شد",
  Torry_edited_successfully: "توری با موفقیت ویرایش گردید",
  Lace_added_successfully: "توری با موفقیت اضافه شد",
  Tori_removed_successfully: "توری با موفقیت حذف گردید",
  changeWeightSuccess: "وزن با موفقیت ویرایش شد",
  settings_saved_successfully: "تنظیمات با موفقیت ثبت شد",
  profile_category_deleted_successfully: "دسته پروفیل با موفقیت حذف گردید",
  successfully_activated: "با موفقیت فعال شد",
  successfully_disabled: "با موفقیت غیرفعال شد",
  profile_handle_updated_successfully: "دسته پروفیل با موفقیت بروز رسانی شد",
  profile_category_successfully_added: "دسته پروفیل با موفقیت اضافه شد",
  name_edited_successfully: "نام با موفقیت ویرایش شد",
  profile_color_added_successfully: "رنگ پروفیل با موفقیت اضافه شد",
  profile_type_added_successfully: "نوع پروفیل با موفقیت اضافه شد",
  profile_color_was_successfully_deleted: "رنگ پروفیل با موفقیت پاک شد",
  profile_color_successfully_disabled: "رنگ پروفیل با موفقیت غیرفعال شد",
  profile_type_deleted_successfully: "نوع پروفیل با موفقیت پاک شد",
  profile_type_successfully_deactivated: "نوع پروفیل با موفقیت غیرفعال شد",
  successfully_edited_crop_fraction: "ویرایش کسری برش با موفقیت انجام شد",
  group_price_change_successfully: "تغییر گروهی قیمت با موفقیت انجام شد",
  color_disabled: "رنگ غیر فعال شد",
  color_activated: "رنگ فعال شد",
  color_type_disabled: "نوع رنگ غیر فعال شد",
  color_type_enabled: "نوع رنگ فعال شد",
  Rokub_editing_was_done_successfully: "ویرایش روکوب با موفقیت انجام گردید",
  New_Roku_was_registered_successfully: "روکوب جدید با موفقیت ثبت گردید",
  The_tracking_was_successfully_removed: "روکوب با موفقیت حذف گردید",
  Rocube_has_been_successfully_disabled: "روکوب با موفقیت غیر فعال شد",
  The_new_service_was_successfully_registered: "خدمات جدید با موفقیت ثبت گردید",
  Service_edited_successfully: "خدمات با موفقیت ویرایش گردید",
  The_service_was_successfully_removed: "خدمات با موفقیت حذف گردید",
  Hardware_brand_added_successfully: "برند یراق با موفقیت اضافه شد",
  Opener_successfully_added: "بازشو با موفقیت اضافه شد",
  Brand_added_successfully: "برند با موفقیت اضافه شد",
  Hardware_has_been_cleared_successfully: "یراق با موفقیت پاک شد",
  The_popup_was_successfully_removed: "بازشو با موفقیت حذف گردید",
  Range_Cleared_Successfully: "محدوده با موفقیت پاک شد",
  Editing_the_hardware_range_was_successful:
    "ویرایش محدوده یراق با موفقیت انجام شد",
  New_range_successfully_added: "محدوده جدید با موفقیت اضافه شد",
  password_change_successfully: "عملیات تغییر رمز عبور با موفقیت انجام گردید",
  registered_successfully:
    "اطلاعات شما با موفقیت ثبت گردید مشخصات کاربری برای شما پیامک میشود",
  Customer_added_successfully: "مشتری با موفقیت اضافه گردید",
  The_client_was_successfully_deleted: "مشتری با موفقیت حذف گردید",
  Customer_information_successfully_edited: "اطلاعات مشتری با موفقیت ویرایش شد",
  Customer_group_added_successfully: "گروه مشتری با موفقیت اضافه شد",
  Customer_group_edited_successfully: "گروه مشتری با موفقیت ویرایش شد",
  Customer_group_deleted_successfully: "گروه مشتری با موفقیت پاک شد",
  Template_added_successfully: "الگو با موفقیت اضافه گردید",
  Pattern_deleted_successfully: "الگو با موفقیت حذف گردید",
  The_template_was_edited_successfully: "الگو با موفقیت ویرایش گردید",
  Project_successfully_added: "پروژه با موفقیت اضافه شد",
  Project_deleted_successfully: "پروژه با موفقیت حذف گردید",
  Project_information_edited_successfully: "اطلاعات پروژه با موفقیت ویرایش شد",
  Production_settings_successfully_completed:
    "تنظیمات تولید با موفقیت انجام شد",
  Financial_settings_completed_successfully: "تنظیمات مالی با موفقیت انجام شد",
  User_edited_successfully: "کاربر با موفقیت ویرایش شد",
  User_deleted_successfully: "کاربر با موفقیت حذف گردید",
  User_group_added_successfully: "گروه کاربر با موفقیت اضافه شد",
  User_group_edited_successfully: "گروه کاربر با موفقیت ویرایش شد",
  User_group_deleted_successfully: "گروه کاربر با موفقیت پاک شد",
  unit_images: "تصاویر یونیت",
  QC_prj_Label: "برچسب کنترل کیفیت پروژه",
  QC_glass_Label: "برچسب کنترل کیفیت شیشه",
  QC_ProductionCardWithDetails: "کارت تولید همراه جزئیات",
  QC_LargerUnitImages: "تصاویر یونیت بزرگتر",
  general_consumable: "اقلام مصرفی به صورت کلی",
  per_unit_consumable: "اقلام مصرفی به صورت یونیت به یونیت",
  general_fittings: "ریز یراق آلات به صورت کلی",
  per_unit_fittings: "ریز یراق آلات به صورت یونیت به یونیت",
  technical_fittings: "محدوده فنی یراق آلات",
  isOther: "اقلام جانبی",
  isFrame: "فریم",
  isSash: "سش",
  isSashDoor: "سش در",
  isMullion: "مولیون",
  isMulion: "مولیون",
  isGlazing: "زهوار",
  isRokob: "روکوب",
  isInterLock: "اینترلاک",
  isConectorSash: "کانکتور سش",
  isOtherPop: "اقلام دیگر لولایی",
  isOtherRail: "اقلام دیگر کشویی",
  isPanel: "پانل",
  isProfileKomaki: "پروفیل کمکی",
  thickness: "ضخامت",
  brandName: "نام برند",
  weight: "وزن",
  ProfileTypeList: "لیست نوع پروفیل",
  ProfileCatName: "نام دسته پروفیل",
  moveHandlePlace: "جابجایی محل دستگیر",
  payment: "پرداخت",
  upload: "آپلود فایل",
  selectedFile: "فایل انتخاب شده",
  notSelectedFile: "فایل انتخاب نشده",
  ticket_details: "جزئیات تیکت پشتیبانی",
  read: "خوانده شده",
  unread: "خوانده نشده",
  isDelete: "حذف شده",
  messageDate: "تاریخ پیام",
  fileAttachment: "فایل ضمیمه",
  viewFile: "مشاهده فایل",
  describe: "توضیحات",
  history_payments: "تاریخچه پرداختی‌ها",
  history_details: "جزئیات تاریخچه اشتراک‌ها",
  profit_and_loss_of_the_project: "سود و زیان پروژه",
  profit_and_loss_list: "لیست سود و زیان",
  calculation_of_profit_and_loss: "محاسبه سود و زیان",
  calculate_based: "محاسبه نسبت به مبلغ",
  price_factor: "مبلغ فاکتور",
  tax: "مالیات",
  profitProfile: "سود پروفیل",
  profitFitting: "سود یراق",
  profitGlass: "سود شیشه",
  profitNet: "سود توری",
  profitOther: "سود اقلام دیگر",
  profitService: "سود خدمات",
  arcCost: "هزینه هلال",
  angleCost: "هزینه زاویه",
  calculation: "محاسبه",
  notification: "پیام ها",
  notifications_list: "لیست پیام",
  title: "عنوان",
  ticketGroup: "زیر گروه",
  tickets: "تیکت‌ها",
  support: "پشتیبانی",
  training: "آموزش",
  tickets_list: "لیست تیکت ها",
  history: "تاریخچه",
  history_list: "تاریخچه دوره",
  units: "یونیت",
  FormContract: "قرارداد",
  form_add_user: "افزایش کاربر",
  current_term_renewal_form: "تمدید دوره جاری",
  panel_information: "مدیریت شارژ حساب",
  wallet: "کیف پول",
  purchase_form: "خرید",
  handlePlace: "محل دستگیره",
  glassFontSize: "سایز فونت شیشه",
  description: "شرح",
  payDescription: "شرح پرداخت",
  contractDescription: "شرح قرارداد",
  usingTime: "زمان استفاده",
  numberUsers: "تعداد کاربر",
  paymentType: "انتخاب نحوه‌ی پرداخت",
  paymentType2: "نحوه‌ی پرداخت",
  amountPaid: "مبلغ پرداختی",
  paymentDocument: "شماره سند",
  bank: "بانک",
  branch: "شعبه",
  contractNumber: "شماره قرارداد",
  button_save: "ثبت",
  register: "تکمیل اطلاعات ثبت نام",
  sent_code: "کد ارسال شده",
  name_company: "نام کارگاه",
  unique: "نام انحصاری",
  stateProject: "دوره",
  number_of_customers: "تعداد مشتریان",
  number_of_projects: "تعداد پروژه ها",
  number_of_factors: "تعداد فاکتور ها",
  print: "چاپ",
  save: "ذخیره فاکتور",
  leafCount: "تعداد لنگه",
  template: "الگو",
  editProject: "ویرایش پروژه",
  state: "وضعیت",
  sysGroup: "نحوه محاسبه",
  windGapWidth: "عرض بادخور",
  sendVerificationCode: "ارسال کد تایید",
  createNewProject: "پروژه جدید",
  statusHistory: "تاریخچه وضعیت ها",
  determineStatusProject: "تعیین وضعیت پروژه",
  searchNameCode: "جستجو نام و کد",
  manageProjects: "مدیریت پروژه ها",
  printInvoice: "چاپ فاکتور",
  cost: "هزینه",
  display: "نمایش",
  factorArchive: "آرشیو فاکتور",
  shippingCost: "حمل و نقل",
  arc: "هلال",
  angles: "زاویه",
  installationCost: "هزینه نصب",
  otherCost: "هزینه جانبی",
  consumedMaterialCost: "هزینه مصرفی",
  discountAmount: "مبلغ تخفیف پس از مالیات",
  materials: "اقلام تولید",
  discount: "تخفیف",
  basePriceDiscount: "تخفیف قیمت پایه",
  basePriceCharge: "افزایش قیمت پایه",
  pricing: "قیمت دهی",
  lengthLessThan: "طول کناره کمتر از این سایز باشد بعنوان ضایعات محاسبه شود",
  casementSystem: "سیستم لولایی",
  slidingSystem: "سیستم کشویی",
  chargeConsumedMaterial: "افزایش مقدار مصرفی",
  invoiceSetting: "تنظیمات فاکتور",
  priceSetting: "تنظیمات قیمت",
  pricingMethod: "روش قیمت دهی پروفیل",
  typeInvoice: "نوع نمایش فاکتور",
  listItems: "لیست یونیت",
  selectProfile: "اجزا پروفیل",
  barLength: "طول شاخه",
  selectPiecesGroup: "گروه اقلام",
  resend: "ارسال دوباره",
  send: "ارسال",
  twoStepLogin: "ورود دو مرحله ای",
  shopPanel: "پنل فروشگاه",
  delete: "پاک کردن",
  IsShowNameProjectOptimal: "نام پروژه",
  IsShowNameUnitOptimal: "نام یونیت",
  IsShowCoverWaterOptimal: "کاور آب",
  IsShowHandleOptimal: "دستگیره",
  IsShowLolaOptimal: "لولا",
  CoverWaterFrame: "کاور فریم",
  CoverWaterMulion: "کاور مولیون",
  CoverWaterTop: "کاور بالا",
  CoverWaterbot: "کاور پایین",
  optimization: "بهینه سازی",
  locationCover: "محل کاور",
  railChannelCoverProfile: "زهوار باران گیر",
  requestChangeStatus: "تغییر وضعیت",
  thresholdBottom: "فاصله آستانه از کف",
  thresholdTop: "فاصله آستانه از ارتفاع",
  couple: "کوپل",
  glazing: "زهوار",
  glassGroup: "گروه شیشه",
  brand: "برند",
  pop: "بازشو",
  consumedFoam: "فوم مصرفی",
  consumedMastic: "ماستیک مصرفی",
  nameUnit: "نام یونیت",
  ـnameUnit: "نام",
  placeLocation: "محل نصب",
  numberUnit: "تعداد یونیت",
  superVisor: "کاربر ناظر",
  agent: "کاربر نماینده",
  groupedAgents: "نمایندگان گروهبندی شده",
  unGroupedAgents: "نمایندگان گروهبندی نشده",
  factors: "فاکتور ها",
  User_Supervisor_Replace: "جایگزین کاربر ناظر: ",
  User_Supervisor_Group: "گروه بندی",
  Manage_User_Supervisor: "مدیریت کاربران ناظر",
  priceProfile: "قیمت پروفیل",
  priceGlass: "قیمت محصول شیشه",
  priceNet: "قیمت توری",
  priceOther: "قیمت دیگر اقلام",
  priceFitting: "قیمت یراق",
  parts: "اجزا",
  CheckTell: "تلفن",
  CheckAddress: "آدرس",
  CheckWeb: "وب",
  CheckEmail: "ایمیل",
  CheckLogo: "لوگو",
  CheckHeader: "هدر",
  CheckFooter: "فوتر",
  WaterMark: "سربرگ",
  CheckHeaderSlogan: "شعار شرکت",
  userAccessFactor: "سطح دسترسی فاکتور به کاربران",
  count: "تعداد",
  windGapHeight: "ارتفاع بادخور",
  location: "محل نصب",
  services: "خدمات",
  Spicer: "اسپیسر",
  GroupGlass: "گروه شیشه",
  ProductGlass: "محصول شیشه",
  FoamMastic: "فوم و ماستیک",
  SeriProfile: "سری پروفیل",
  Khadmat: "خدمات",
  Setting: "تنظیمات",
  Flashing: "روکوب",
  FixerLastic: "فیکسر لاستیک",
  deleteInfo: "حذف اطلاعات",
  Workshop: "ساخت",
  TypeColor: "گروه انتخاب رنگ",
  Template: "الگو",
  Statistics: "آمار",
  ChangeStateProject: "تغییر وضعیت پروژه",
  EditUserAccess: "سطح دسترسی کاربر",
  profit: "سود و زیان",
  contract: "قرارداد",
  Show: "نمایش",
  Delete: "حذف",
  Edit: "ویرایش",
  Register: "ثبت",
  Price2: "قیمت کاربر",
  WorkShop: "کارگاهی",
  CutGlass: "گزارش شیشه",
  production: "ساخت",
  Factor: "فاکتور",
  Designer: "طراحی",
  GroupCustomer: "مشتری",
  value: "مقدار",
  unitPrice: "مبلغ واحد",
  bottom_jamb: "پاخور",
  lifting_profile: "ارتفاع دهنده",
  threshold: "آستانه",
  flashing: "روکوب",
  fitScreen: "جانمایی",
  equalGlass: "شیشه مساوی",
  coverWater: "کاور کانال آب",
  edit_pattern: "ویرایش الگو",
  others: "اقلام",
  zehvar: "زهوار",
  panel: "پانل",
  sash_door: "سش در",
  frame: "فریم",
  sash: "سش",
  mulion: "مولیون",
  preview: "مشاهده گزارش",
  download: "دانلود",
  disable: "غیرفعال",
  unchangeable: "غیر قابل تغییر",
  construction: "ساخت",
  active: "فعال",
  spacer: "اسپیسر",
  tanzimatGozareshatMali: "فاکتور",
  tanzimatGozareshatTolide: "ساخت",
  tanzimatTarahi: "طراحی",
  tanzimatShop: "شبکه‌فروش",
  name: "نام",
  shomareEghtesadi: "شماره اقتصادی",
  mobile: "موبایل",
  telephone: "تلفن",
  last_Name: "نام‌ و نام خانوادگی",
  fax: "فکس",
  customerGroup: "گروه مشتریان",
  customerGroups: "گروه‌های مشتریان",
  ostan: "استان",
  city: "شهر",
  address: "آدرس",
  chargeOther: "دیگر",
  discountOther: "دیگر",
  displayName: "نام کامل",
  email: "ایمیل",
  group: "گروه",
  stypePanel: "StypePanel",
  phoneNumber: "شماره تماس",
  userName: "نام کاربری",
  password: "رمزعبور",
  Other: "دیگر",
  Service: "سرویس",
  moshtari_jadid: "مشتری جدید",
  groh_moshtari: "گروه مشتریان",
  list_rokob: "لیست روکوب",
  list_Khadmat: "لیست خدمات",
  list_FomMastik: "لیست فوم و ماستیک",
  moshtari: "مشتری",
  list_moshtari: "لیست مشتری",
  virayesh: "ویرایش",
  virayesh_moshtari: "ویرایش مشتری",
  sakht_groh_jadid: "ساخت گروه جدید",
  newCustomerGroup: "ساخت گروه مشتریان جدید",
  newUserGroup: "ساخت گروه مالی جدید",
  name_groh_jadid: "نام گروه",
  convertGroup: "نوع گروه تبدیل",
  convertFrom: "تبدیل از",
  convertTo: "تبدیل به",
  unit_convert: "تبدیل موقت یونیت",
  unit_convert2: "تبدیل دائم یونیت",
  convertProfile: "انتخاب اجزا",
  darsad_sharj: "درصد شارژ",
  darsad_takhfif: "درصد تخفیف",
  ezafe_be_list: "اضافه به لیست",
  add_project_to_list: "اضافه کردن پروژه به لیست",
  ble_pak_shavad: "بله، حذف شود",
  enseraf: "انصراف",
  aya_az_hazf_an_etminan_darid: "آیا از حذف اطمینان دارید؟",
  did_you_receive_text_message: "ارسال مجدد کد؟",
  welcome_software: "به نرم‌افزار درساوین خوش آمدید",
  please_wait_to_receive_the_verification_code:
    "لطفا برای دریافت کد تایید منتظر بمانید...",
  hazf: "حذف",
  list_karbaran: "لیست کاربران",
  moderiyat_karbaran: "مدیریت کاربران",
  karbar_jadid: "کاربر جدید",
  groh_mali_karbaran: "گروه مالی کاربران",
  ejad_hesab_karbari_jadid: "ایجاد حساب کاربری جدید",
  Manage_User: "مدیریت کاربران",
  customerGroupMali: "گروه مالی مشتریان",
  list_olgo: "لیست الگوها",
  select_olgo: "انتخاب الگو",
  list_shishe: "لیست محصولات شیشه",
  list_tori: "لیست توری",
  list_yaragh: "لیست محدوده تجاری",
  list_Fani: "لیست محدوده فنی",
  MahdoodeFani: "محدوده فنی",
  MahdoodeYaragh: "محدوده تجاری",
  yaraghProductList: "لیست کالاها",
  standardCode: "کد استاندارد",
  partCount: "تعداد",
  stuffAx: "آکس",
  stuffSide: "جهت",
  stuffColor: "رنگ",
  stuffLevelSecurity: "سطح ایمنی",
  newStuff: "کالای جدید",
  editStuff: "ویرایش کالا",
  addNewStuff: "افزودن کالا",
  add_new_stuff: "کالای جدید با موفقیت اضافه شد",
  edit_stuff: "کالا با موفقیت ویرایش شد",
  remove_stuff: "کالا با موفقیت پاک شد",
  edit_stuffCount: "ویرایش تعداد",
  copy_product: "کپی کالا",
  copy_product_successfully: "کپی کالا با موفقیت انجام شد",
  copy_product_to: "کپی در",
  same_source_and_destination: "مبدا و مقصد کپی نباید یکسان باشد",
  list_profile: "لیست مشخصات پروفیل",
  profileSeries: "سری پروفیل",
  close: "بستن",
  profile_category_archive: "بانک سری پروفیل ها",
  fixer_and_rubber_pricing: "قیمت دهی فیکسر و لاستیک",
  profileTypeColor: "نوع و رنگ پروفیل",
  profileCategory: "سری ‌پروفیل",
  newProfileTypeColor: "نوع و رنگ پروفیل جدید",
  listColors: "لیست رنگ ها",
  profileTypeColorSetting: "تنظیمات نوع و رنگ پروفیل",
  Reinforcement_cutting_decrease_setting: "تنظیمات کسری برش گالوانیزه",
  total: "مقدار را وارد کنید",
  isPercent: "",
  changeType: "",
  typesList: "نوع پروفیل",
  colorList: "رنگ پروفیل",
  nameBrand: "جستجو برند",
  nameSearch: "جستجو نام",
  usernameSearch: "جستجو نام کاربری",
  keshvar: "کشور",
  country: "کشور",
  selectType: "نوع",
  struct: "جنس",
  zobFrame: "ذوب فریم",
  zobSash: "ذوب سش",
  sarboreshMolion: "سر برش مولیون",
  sarboreshMolionKatibe: "سر برش مولیون کتیبه",
  fazayeAzadAverhung: "فضای آزاد آورهانگ",
  badkhorFrameSash: "بادخور شیشه(فریم/سش)",
  badkhorMolion: "بادخور شیشه(مولیون)",
  hampushaniW: "همپوشانی عرض",
  virayesh_Olgu: "ویرایش الگو",
  hampushaniH: "همپوشانی ارتفاع",
  hampushaniKaman: "همپوشانی کمان",
  sizeDarpush: "سایز در پوش آورهانگ",
  badkhorPanelFrame: "بادخور پانل(فریم/سش)",
  badkhorPanelMolion: "بادخور پانل(مولیون)",
  IncArcFrame: "افزایشی کمان (فریم)",
  IncArcSash: "افزایشی کمان (سش)",
  IncArcGlazing: "افزایشی کمان (زهوار)",
  IsZehvar90: "برش زهوار 90 درجه",
  fomMastikType: "نوع فوم / ماستیک",
  nameType: "نوع پروفیل",
  nameColor: "نام رنگ",
  dasteProfile: "سری پروفیل",
  newPattern: "الگو جدید",
  searchProfileCategories: "جستجو سری پروفیل",
  type: "نوع",
  typeColor: "نوع پروفیل",
  color: "رنگ",
  brandYaragh: "برند یراق",
  shisheGroup: "گروه شیشه",
  sashDoor: "سش در",
  overhung: "آورهانگ",
  profileKomaki: "پروفیل کمکی",
  zehvar1: "زهوار تک جداره",
  zehvar2: "زهوار دو جداره",
  zehvar3: "زهوار سه جداره",
  brandFitting: "برند یراق",
  molionKatibeh: "مولیون کتیبه",
  molionFrame: "مولیون فریم",
  interLock: "اینتر لاک",
  conectorSash: "کانکتور سش",
  zehvarBaran: "زهوار باران گیر",
  status: "وضعیت",
  newNet: "توری جدید",
  addNewNet: "اضافه کردن توری جدید",
  other: "دیگر",
  service: "سرویس",
  displayUser: "نام کامل",
  userGroup: "گروه کاربر",
  userGroups: "گروه‌های مالی کاربران",
  stypeUser: "نقش کاربر",
  virayesh_users: "ویرایش کاربران",
  mahdoodeName: "نام محدوده",
  priceMahdoode: "قیمت",
  yaraghBrand: "برند یراق",
  archiveFittingBrand: "آرشیو برند یراق",
  yaraghName: "برند یراق",
  priceTori: "قیمت",
  price: "قیمت",
  halatBazsho: "حالت بازشو",
  bazshoName: "نام بازشو",
  addNewPop: "اضافه کردن بازشو جدید",
  addNewBrandFitting: "اضافه کردن برند یراق جدید",
  editBrandFitting: "ویرایش نام برند یراق",
  editBazshoFitting: "ویرایش نام بازشو",
  successfullyEditBazshoFitting: "ویرایش نام بازشو با موفقیت انجام شد",
  priceChangeInGroup: "تغییر گروهی قیمت",
  minW: "حداقل عرض",
  maxW: "حداکثر عرض",
  maxH: "حداکثر ارتفاع",
  minH: "حداقل ارتفاع",
  virayesh_MahdoodeYaragh: "ویرایش محدوده یراق",
  newAccessoryRange: "محدوده تجاری جدید",
  newAccessoryRangeFani: "محدوده فنی جدید",
  MahdoodeFaniProductManagement: "مدیریت کالاها",
  addNewAccessoryRange: "اضافه کردن محدوده یراق جدید",
  typeGroup: "انتخاب نوع",
  spacer_manage: "مشخصات اسپیسر",
  glass_manage: "مشخصات شیشه",
  glass_group_manage: "گروه بندی محصولات شیشه",
  new_glass_product: "محصول شیشه جدید",
  edit_glass_product: "ویرایش محصول شیشه",
  jedare: "جداره",
  nameshishe: "نام شیشه",
  spacerName: "نام اسپیسر",
  thick: "ضخامت",
  shisheName: "نام شیشه جدید",
  shisheGroupName: "نام گروه شیشه",
  editShisheGroup: "ویرایش گروه شیشه",
  nameRokub: "نام روکوب",
  newService: "خدمت جدید",
  addNewService: "اضافه کردن خدمت جدید",
  priceRokub: "قیمت",
  nameFomMastik: "نام فوم و ماستیک",
  newFomMastik: "فوم و ماستیک جدید",
  newFlashing: "روکوب جدید",
  addNewFlashing: "اضافه کردن روکوب جدید",
  addNewFomMastik: "اضافه کردن فوم و ماستیک جدید",
  cover: "مقدار قابل پوشش برحسب مترطول",
  priceFomMastik: "قیمت",
  calculationType: "نحوه محاسبه",
  titleService: "عنوان خدمت",
  priceService: "قیمت",
  virayesh_Khedmat: "ویرایش خدمات",
  groupPrice: "قیمت ادمین",
  userPrice: "قیمت کاربر",
  virayesh_FomMastik: "ویرایش فوم وماستیک",
  virayesh_Rokub: "ویرایش  روکوب",
  virayesh_tori: "ویرایش  توری",
  incW: "± عرض لنگه",
  incH: "± ارتفاع لنگه",
  glassCalc: "حداقل سایز شیشه",
  netCalc: "حداقل سایز توری",
  costArc: "هزینه تولید زاویه",
  costAngle: "هزینه تولید هلال",
  header: "متن هدر",
  headerSlogan: "متن شعار شرکت",
  tell: "شماره تماس",
  phone: "شماره تماس",
  web: "آدرس سایت",
  footer: "متن فوتر",
  zakhirTanzimatMali: "ذخیره تنظیمات فاکتور",
  financialReportSettings: "تنظیمات فاکتور",
  productionReportSettings: "تنظیمات ساخت",
  designSettings: "تنظیمات  طراحی",
  shopSettings: "تنظیمات شبکه فروش",
  unitName: "نام طراحی",
  breakW: "باد خور یونیت عرض",
  breakH: "باد خور یونیت ارتفاع",
  sizeFontDesigner: "طراحی سایز فونت",
  limitCouple: "طراحی فاصله مجاز کوپل",
  limitMulion: "طراحی فاصله مجاز مولیون",
  limitGuidLine: "طراحی فاصله بین خطوط راهنما",
  zakhire_tanzimat_tarahi: "ذخیره تنظیمات طراحی",
  bladeThickProfile: "ضخامت تیغه پروفیل",
  bladeThickGalvanize: "ضخامت تیغه گالوانیزه",
  wasteSizeProfile: "سایز ضایعات پروفیل",
  wasteSizeGalvanize: "سایز ضایعات گالوانیزه",
  glassFixer: "تعداد زیر شیشه ای فیکس",
  bazsho: "تعداد زیر شیشه ای بازشو",
  countMinScrewIron: "پیچ گالوانیزه حداقل سایز دو عدد",
  countBetweenScrowIron: "پیچ گالوانیزه فاصله بین",
  minOneCoveWater: "کاور آبچکان یک عدد حداقل",
  maxOneCoveWater: "کاور آبچکان یک عدد حداکثر",
  minTwoCoveWater: "کاور آبچکان دو عدد حداقل",
  maxTwoCoveWater: "کاور آبچکان دو عدد حداکثر",
  zakhireTanzimatTolid: "ذخیره تنظیمات ساخت",
  selectProjectTable: "انتخاب/قفل",
  projectName: "نام پروژه",
  project_name_input: "نامی برای پروژه‌تان انتخاب کنید",
  maliyat: "مالیات",
  nasb: "نصب",
  mavadMasrafi: "مواد مصرفی",
  projectsList: "لیست پروژه",
  virayesh_project: "ویرایش اطلاعات پروژه",
  projectStatus: "وضعیت پروژه",
  Appendix: "ضمیمه",
  projects: "پروژه",
  design: "طراحی",
  invoices: "فاکتور",
  customers: "مشتری",
  customers_name_input: "مشتری خود را انتخاب کنید",
  properties: "مشخصات",
  patterns: "الگو",
  patternsGroup: "گروه الگو",
  users: "کاربران",
  settings: "تنظیمات",
  button_register_password: "ثبت رمز جدید",
  header_welcome: "به وب‌وین خوش آمدید",
  header_enter_your_information_to_enter_the_panel:
    "لطفا برای ورود به پنل اطلاعات خود را وارد کنید",
  input_userName: "نام کاربر",
  input_password: "رمز عبور",
  button_forgot_password: "رمز عبور خود را فراموش کرده‌اید؟",
  button_return_login: "بازگشت به صفحه ورود",
  button_login: "ورود",
  button_signup: "ثبت نام (رایگان)",
  button_send_code: "ارسال کد",
  header_password_recovery: "بازیابی رمز عبور",
  input_phone: "شماره همراه",
  err_emailIsNull: "لطفا ایمیل خود را وارد کنید",
  err_mobileIsNull: "لطفا شماره تلفن همراه خود را وارد کنید",
  err_mobileNotValid: "شماره تلفن همراه معتبر نمی باشد",
  err_emailNotValid: "آدرس ایمیل معتبر نمی باشد",
  err_isNull: "فیلد خالی می باشد",
  olgo: "الگو",
  rokob: "روکوب",
  va: "و",
  nameProfile: "نام پروفیل",
  size: "سایز",
  sizeV2: "ابعاد (میلیمتر)",
  gheimat: "قیمت",
  moratabSazi: "مرتب سازی",
  astaneVaPakhor: "آستانه و پاخور",
  sabtenam: "ایجاد حساب کاربری",
  user_Account: "حساب کاربری",
  resetPassword: "تنظیم مجدد رمز عبور",
  Shomare: "کد",
  taeed: "تایید",
  fullName: "نام کامل",
  newPassword: "رمز عبور جدید",
  oldPassword: "رمز عبور قدیم",
  vaziyat: "وضعیت",
  faal: "فعال",
  gheirFaal: "مسدود",
  zakhire: "ذخیره",
  _zakhire: "ذخیره طراحی",
  ezafeKardan: "اضافه کردن",
  fullscreen: "بزرگنمایی",
  ListBoresh: "لیست برش",
  behinehSaziGalvanize: "گالوانیزه",
  AglamMasrafi: "اقلام مصرفی",
  controlkeyfiat: "کنترل کیفیت",
  accountDarid: "آیا حساب کاربری دارید؟",
  noDataText: "اطلاعاتی برای نمایش موجود نمی باشد",
  _noDataText: "اطلاعاتی وجود ندارد",
  sharayeteEstefadeAzKhadamat: "شرایط استفاده از خدمات",
  faalYaMasdood: "فعال یا مسدود کردن کاربر؟",
  etminanHazf: "آیا مطمعن به حذف این کاربر هستید؟",
  brand_name: "درساوین",
  statistic: "آمار",
  statotal: "آمار کلی",
  groupProfile: "دسته پروفیل",
  period: "فاصله زمانی",
  filter: "فیلتر",
  backToList: "بازگشت به لیست",
  acceptance_rules_p1: "حریم خصوصی  وب وین",
  acceptance_rules_p2: "را مطالعه نموده ام و با کلیه موارد آن موافق هستم.",
  share: "اشتراک گذاری",
  moreInfoInShare: "ساخته شده در نرم افزار وب وین",
  share_success: "فایل ارسال شد",
  share_error: "فایل ارسال نشد",
  share_device_notCompatible: "مرورگر شما قادر به ارسال فایل نمی‌باشد",
  search: "جستجو",
  newProjectAddressInfo: "آدرس محل اجرای پروژه را وارد کنید:",
  notSelected: "انتخاب نشده",
  selectOneItem: "یک مورد را انتخاب کنید",
  newNotification: "شما یک پیام جدید دارید",
  priceNotEntered: "قیمت وارد نشده",
  customer_edit_custom_charge: "ویرایش درصد شارژ سفارشی برای این دسته",
  customer_edit_custom_discount: "ویرایش درصد تخفیف سفارشی برای این دسته",
  customer_apply_custom_charge: "اعمال درصد شارژ سفارشی برای این دسته",
  customer_apply_custom_discount: "اعمال درصد تخفیف سفارشی برای این دسته",
  bankProblem: "درگاه بانکی در حال بروزرسانی می‌باشد",
  up: "بالا",
  down: "پایین",
  stfh_adjustment: "تنظیمات روکوب،آستانه،پاخور و ارتفاع دهنده",
  elevation_direction: "جهت ارتفاع دهنده",
  select_one_above_below: "بالا یا پایین ؟",
  bottom_footrest_length: "طول پایین پاخور",
  threshold_location: "محل آستانه",
  accordion_Settings: "تنظیمات آکاردئونی",
  accordion: "آکاردئونی",
  clickToSelectDesiredLocation:
    "لطفا برای قرار گیری آکاردئونی روی مکان مورد نظر کلیک کنید",
  dropdown_not_defined: "برای این برند یراق، بازشو مربوطه تعریف نشده است.",
  drawerLock: "قفل دراور",
  SaveUnitOrderSuccessfully: "تغییرات ترتیب با موفقیت ذخیره شد",
  unitReorder: "جابجایی یونیت",
  priceWithTax: "مبلغ پرداختی با احتساب مالیات بر ارزش افزوده می باشد",
  designerBreakFrameDialog: "دوخت پروفیل",
  designerBreakFrame: "محل دوخت",
  isBeforeOptimal: "مدیریت تعداد قطعات پیش از ارسال به بهینه‌سازی",
  managePartsCount: "مشاهده قطعات",
  selectOneProfile: "یک پروفیل را انتخاب کنید",
  pieceCount: "تعداد",
  pieceLength: "طول",
  newValueNotBiggerAllowed: "مقدار جدید نباید از مقدار قبلی بزرگتر باشد",
  newValuesaved: "تعداد جدید ذخیره شد",
  freeAccountLimit: " شما در حال استفاده از نسخه رایگان هستید. برای دسترسی به این قابلیت و امکانات بیشتر، نسخه حرفه‌ای را فعال کنید",
  invalidWebSite_t1: "این وب‌سایت از شرکت فناوری داده پویشگر مجوز معتبر دریافت نکرده است",
  invalidWebSite_t2: "برای اطلاعات بیشتر با پشتیبانی تماس بگیرید",
  login_text_custom: "اختصاصی برای فروشندگان و تولیدکنندگان صنعت در و پنجره",

  //todo
  //todo
  //todo
  //todo add in En
  //todo
  //todo
  //todo
  structFrame: "ساختار فریم",
  newPatternGroup: "گروه الگو جدید",
  editPatternGroup: "ویرایش گروه الگو",
  patternListInGroup: "لیست الگوها",
  listPatternGroup: "لیست گروه های الگو",
  deleteGlass: "حذف شیشه",
  addProject: "اضافه کردن پروژه",
  minWstandard: "حداقل عرض استاندارد",
  maxWstandard: "حداکثر عرض استاندارد",
  maxHstandard: "حداکثر ارتفاع استاندارد",
  minHstandard: "حداقل ارتفاع استاندارد",
  unitDetailsAttachment: "لینک‌های معرفی یونیت",
  link: "لینک",
  shortDescribe: "توضیحات کوتاه",
  photo: "عکس",
  video: "فیلم",
  addNewLink: "لینک جدید",
  editLink: "ویرایش لینک",
  addedLinks: "لینک‌ها",

  //todo
  //todo
  //todo
  //todo add in En
  //todo
  //todo
  //todo
  structFrame: "ساختار فریم",
  newPatternGroup: "گروه الگو جدید",
  editPatternGroup: "ویرایش گروه الگو",
  patternListInGroup: "لیست الگوها",
  listPatternGroup: "لیست گروه های الگو",
  deleteGlass: "حذف شیشه",
  addProject: "اضافه کردن پروژه",
  minWstandard: "حداقل عرض استاندارد",
  maxWstandard: "حداکثر عرض استاندارد",
  maxHstandard: "حداکثر ارتفاع استاندارد",
  minHstandard: "حداقل ارتفاع استاندارد",
  unitDetailsAttachment: "لینک‌های معرفی یونیت",
  link: "لینک",
  shortDescribe: "توضیحات کوتاه",
  photo: "عکس",
  video: "فیلم",
  addNewLink: "لینک جدید",
  editLink: "ویرایش لینک",
  addedLinks: "لینک‌ها",

  //todo
  //todo
  //todo
  //todo add in En
  //todo
  //todo
  //todo
  structFrame: "ساختار فریم",
  newPatternGroup: "گروه الگو جدید",
  editPatternGroup: "ویرایش گروه الگو",
  patternListInGroup: "لیست الگوها",
  listPatternGroup: "لیست گروه های الگو",
  deleteGlass: "حذف شیشه",
  addProject: "اضافه کردن پروژه",
  minWstandard: "حداقل عرض استاندارد",
  maxWstandard: "حداکثر عرض استاندارد",
  maxHstandard: "حداکثر ارتفاع استاندارد",
  minHstandard: "حداقل ارتفاع استاندارد",
  unitDetailsAttachment: "لینک‌های معرفی یونیت",
  link: "لینک",
  shortDescribe: "توضیحات کوتاه",
  photo: "عکس",
  video: "فیلم",
  addNewLink: "لینک جدید",
  editLink: "ویرایش لینک",
  addedLinks: "لینک‌ها",
  shopNotActivated:
    "«بخش شبکه فروش و دریافت پروژه از طریق سایت اختصاصی شما، برای حساب کاربری‌تان فعال نمی‌باشد. جهت فعال‌سازی با واحد فروش به شماره 02191093601 تماس حاصل فرمایید»",
  cusall: "همه",
  cusreg: "ثبت مستقیم",
  cusshop: "ثبت شبکه‌فروش",
  customersType: "نوع مشتری",
  get_active: "هم اکنون شبکه فروش خود را فعال کنید",
  tag: "انیمیشن تگ",

  //todo [Tools Side Drawer]
  tool_side_drawer_Select: "انتخاب",
  tool_side_drawer_Clear: "پاک کن",
  tool_side_drawer_Vertical_connection: "اتصال عمودی",
  tool_side_drawer_Horizontal_connection: "اتصال افقی",
  tool_side_drawer_Vertical_mullion: "مولیون عمودی",
  tool_side_drawer_Horizontal_mullion: "مولیون افقی",
  tool_side_drawer_Horizontal_divider: "تقسیم کننده افقی",
  tool_side_drawer_Vertical_divider: "تقسیم کننده عمودی",
  tool_side_drawer_Full_mullion: "مولیون سراسری",
  tool_side_drawer_Transom_mullion: "مولیون کتیبه",
  tool_side_drawer_Single_wl: "پنجره تک حالته چپ بازشو",
  tool_side_drawer_Single_wr: "پنجره تک حالته راست بازشو",
  tool_side_drawer_Dual_wl: "پنجره دو حالته چپ بازشو",
  tool_side_drawer_Dual_wr: "پنجره دو حالته راست بازشو",
  tool_side_drawer_oTop: "پنجره بالا بازشو",
  tool_side_drawer_oBottom: "پنجره پایین بازشو",
  tool_side_drawer_Volkswagen: "فولکس واگن",
  tool_side_drawer_French_window: "پنجره فرانسوی",
  tool_side_drawer_Single_dl: "در تک حالته چپ بازشو",
  tool_side_drawer_Single_dr: "در تک حالته راست بازشو",
  tool_side_drawer_Dual_door: "در دو حالته",
  tool_side_drawer_French_door: "در فرانسوی",
  tool_side_drawer_Accordion: "آکاردئونی",
  tool_side_drawer_Single_2s: "کشویی تک ریل دو لنگه",
  tool_side_drawer_Single_3s: "کشویی تک ریل سه لنگه",
  tool_side_drawer_Single_4s: "کشویی تک ریل چهار لنگه",
  tool_side_drawer_Double_2s: "کشویی جفت ریل دو لنگه",
  tool_side_drawer_Double_3s: "کشویی جفت ریل سه لنگه",
  tool_side_drawer_Double_4s: "کشویی جفت ریل چهار لنگه",
  tool_side_drawer_Triple_3s: "کشویی سه ریل سه لنگه",
  tool_side_drawer_Triple_5s: "کشویی سه ریل پنج لنگه",
  tool_side_drawer_Triple_6s: "کشویی سه ریل شش لنگه",
  tool_side_drawer_Quad_4s: "کشویی چهار ریل چهار لنگه",
  tool_side_drawer_Quad_6s: "کشویی چهار ریل شش لنگه",
  tool_side_drawer_Quad_7s: "کشویی چهار ریل هفت لنگه",
  tool_side_drawer_Quad_8s: "کشویی چهار ریل هشت لنگه",
  tool_side_drawer_sash_net: "توری و لنگه فیکس",
  tool_side_drawer_Net: "توری",
  tool_side_drawer_FixedSash: "لنگه فیکس",
  tool_side_drawer_Panel: "پانل",
  tool_side_drawer_Beading: "روکوب، آستانه، پاخور و ارتفاع دهنده",

  //todo [Shapes List]
  Rectangle: "مستطیل",
  Two_rectangles_inside_each_other_1: "دو مستطیل داخل هم 1",
  Two_rectangles_inside_each_other_2: "دو مستطیل داخل هم 2",
  Two_rectangles_inside_each_other_3: "دو مستطیل داخل هم 3",
  Two_rectangles_inside_each_other_4: "دو مستطیل داخل هم 4",
  Horizontal_eye: "چشمی افقی",
  Vertical_eye: "چشمی عمودی",
  Two_bent_corners_1: "دو گوشه خم 1",
  Two_bent_corners_2: "دو گوشه خم 2",
  Two_bent_corners_3: "دو گوشه خم 3",
  Two_bent_corners_4: "دو گوشه خم 4",
  Two_bent_corners_u4: "دو گوشه خم u4",
  Two_bent_corners_u1: "دو گوشه خم u1",
  Two_bent_corners_u3: "دو گوشه خم u3",
  Two_bent_corners_5: "دو گوشه خم 5",
  Two_bent_corners_j1: "دو گوشه خم j1",
  Two_bent_corners_j2: "دو گوشه خم j2",
  Two_diagonal_corners_1: "دو گوشه مورب 1",
  Two_diagonal_corners_2: "دو گوشه مورب 2",
  Two_diagonal_corners_3: "دو گوشه مورب 3",
  Two_diagonal_corners_4: "دو گوشه مورب 4",
  Horizontal_trapezoid_1: "ذوزنقه افقی 1",
  Horizontal_Trapezoid_2: "ذوزنقه افقی 2",
  Horizontal_Trapezoid_3: "ذوزنقه افقی 3",
  Horizontal_Trapezoid_4: "ذوزنقه افقی 4",
  Vertical_Trapezoid_1: "ذوزنقه عمودی 1",
  Vertical_Trapezoid_2: "ذوزنقه عمودی 2",
  Vertical_Trapezoid_3: "ذوزنقه عمودی 3",
  Vertical_Trapezoid_4: "ذوزنقه عمودی 4",
  Isosceles_Trapezoid_1: "ذوزنقه متساوی الساقین 1",
  Isosceles_Trapezoid_2: "ذوزنقه متساوی الساقین 2",
  Isosceles_Trapezoid_3: "ذوزنقه متساوی الساقین 3",
  Isosceles_Trapezoid_4: "ذوزنقه متساوی الساقین 4",
  Various_Sided_Trapezoid_1: "ذوزنقه مختلف اضلاع 1",
  Various_Sided_Trapezoid_2: "ذوزنقه مختلف اضلاع 2",
  Various_Sided_Trapezoid_3: "ذوزنقه مختلف اضلاع 3",
  Various_Sided_Trapezoid_4: "ذوزنقه مختلف اضلاع 4",
  Quarter_Circle_1: "ربع دایره 1",
  Quarter_Circle_2: "ربع دایره 2",
  Quarter_Circle_3: "ربع دایره 3",
  Quarter_Circle_4: "ربع دایره 4",
  Quarter_Circle_with_Arc_Adjustment_1: "ربع دایره با تنظیم قوس 1",
  Quarter_circle_with_arc_adjustment_3: "ربع دایره با تنظیم قوس 3",
  Quarter_circle_with_arc_adjustment_4: "ربع دایره با تنظیم قوس 4",
  Bent_triangle_1: "سه گوشه خم 1",
  Bent_triangle_2: "سه گوشه خم 2",
  Bent_triangle_3: "سه گوشه خم 3",
  Bent_triangle_4: "سه گوشه خم 4",
  Diagonal_triangle_1: "سه گوشه مورب 1",
  Diagonal_triangle_2: "سه گوشه مورب 2",
  Diagonal_triangle_3: "سه گوشه مورب 3",
  Diagonal_triangle_4: "سه گوشه مورب 4",
  Right_triangle_1: "مثلث قائم الزاویه 1",
  Right_triangle_3: "مثلث قائم الزاویه 3",
  Right_triangle_4: "مثلث قائم الزاویه 4",
  Cottage_1: "کلبه ای 1",
  Cottage_2: "کلبه ای 2",
  Round_cottage_1: "کلبه ای گردی 1",
  Round_cottage_2: "کلبه ای گردی 2",
  Diagonal_cottage_1: "کلبه ای مورب 1",
  Diagonal_cottage_2: "کلبه ای مورب 2",
  Diagonal_cottage_3: "کلبه ای مورب 3",
  Diagonal_cottage_4: "کلبه ای مورب 4",
  Triangle_Equilateral_1: "مثلث متساوی الاضلاع 1",
  Equilateral_Triangle_2: "مثلث متساوی الاضلاع 2",
  Equilateral_Triangle_3: "مثلث متساوی الاضلاع 3",
  Equilateral_Triangle_4: "مثلث متساوی الاضلاع 4",
  Isosceles_Triangle_1: "مثلث متساوی الساقین 1",
  Isosceles_Triangle_2: "مثلث متساوی الساقین 2",
  Isosceles_Triangle_3: "مثلث متساوی الساقین 3",
  Isosceles_Triangle_4: "مثلث متساوی الساقین 4",
  Parallelogram_1: "متوازی الاضلاع 1",
  Parallelogram_2: "متوازی الاضلاع 2",
  Parallelogram_3: "متوازی الاضلاع 3",
  Parallelogram_4: "متوازی الاضلاع 4",
  Segmented_Triangle_1: "مثلث مختلف الاضلاع 1",
  Segmented_Triangle_2: "مثلث مختلف الاضلاع 2",
  Segmented_Triangle_3: "مثلث مختلف الاضلاع 3",
  Segmented_Triangle_4: "مثلث مختلف الاضلاع 4",
  Square_1: "مربع 1",
  Square_2: "مربع 2",
  Mosque_1: "مسجدی 1",
  Mosque_2: "مسجدی 2",
  Semicircle_with_adjustment_1: "نیم دایره با تنظیم 1",
  Semicircle_with_adjustment_2: "نیم دایره با تنظیم 2",
  Semicircle_with_adjustment_3: "نیم دایره با تنظیم 3",
  Semicircle_with_adjustment_4: "نیم دایره با تنظیم 4",
  Semicircle_1: "نیم دایره 1",
  Semicircle_2: "نیم دایره 2",
  Semicircle_3: "نیم دایره 3",
  Semicircle_4: "نیم دایره 4",
  Cottage_nine_with_adjustment_1: "نبم کلبه ای با تنظیم 1",
  Cottage_nine_with_adjustment_2: "نبم کلبه ای با تنظیم 2",
  Cottage_nine_1: "نبم کلبه ای  1",
  Cottage_nine_2: "نبم کلبه ای  2",
  A_bent_corner_1: "یک گوشه خم  1",
  A_bent_corner_2: "یک گوشه خم  2",
  A_bent_corner_3: "یک گوشه خم  3",
  A_bent_corner_4: "یک گوشه خم  4",
  A_diagonal_corner_1: "یک گوشه مورب  1",
  A_diagonal_corner_2: "یک گوشه مورب  2",
  A_diagonal_corner_3: "یک گوشه مورب  3",
  A_diagonal_corner_4: "یک گوشه مورب  4",

  // todo [some conflict] => [Profile]
  LinedProfile: "پروفیل خطی",
  UnitedProfile: "پروفیل یونیت به یونیت",
  profile: "پروفیل",
  Profile: "پروفیل",
  isProfile: "پروفیل",
  profiles: "پروفیل",
  chargeProfile: "پروفیل",
  discountProfile: "پروفیل",
  behinehSaziProfile: "پروفیل",
  statisticProfile: "پروفیل",

  // todo [some conflict] => [Fitting]
  isFitting: "یراق",
  fittings: "یراق",
  chargeFitting: "یراق",
  discountFitting: "یراق",
  Fitting: "یراق",
  fitting: "یراق",
  yaragh: "یراق",
  statisticFitting: "یراق",

  // todo [some conflict] => [Glass]
  isGlass: "شیشه",
  glasses: "شیشه",
  glassName: "شیشه",
  chargeGlass: "شیشه",
  discountGlass: "شیشه",
  Glass: "شیشه",
  glass: "شیشه",
  shishe: "شیشه",
  statisticGlass: "شیشه",

  // todo [some conflict] => [Net]
  isNet: "توری",
  nets: "توری",
  chargeNet: "توری",
  discountNet: "توری",
  Net: "توری",
  net: "توری",
  tori: "توری",
  statisticNet: "توری",

  //! -> [IMPORT] Api-Result-Messages
  Exception:
    "خطایی در زمان اجرای نرم افزار بوجود آمده است، لطفا در صورت بروز یا مشاهده مجدد این خطا، با بخش پشتیبانی شرکت تماس حاصل فرمایید",
  MinCountRequestSale: "تعداد کاربر کمتر از حداقل مجاز خرید می باشد",
  NotAccessToProject: "دسترسی لازم برای اطلاعات این پروژه برای شما وجود ندارد",
  NotMatchPriceFactor: "مبلغ قرارداد با مجموع مبلغ های ثبت شده یکسان نمی باشد",
  largeFile: "حجم فایل مورد نظر بیش از حد مجاز می باشد",
  NotExistContract: "قراردادی برای پروژه مورد نظر ثبت نشده است",
  TypeFile: "نوع فایل مورد نظر معتبر نمی باشد",
  PleaseSale: "لطفا از سرویس خرید استفاده کنید",
  MinTimePeriodExtenstion:
    "شما فقط میتوانید در انتهای دوره، پلن خود را تمدید نمائید",
  MinInRange: "حداقل تعداد قبلاً در محدوده ای ثبت شده است",
  MaxInRange: "حداکثر تعداد قبلاً در محدوده ای ثبت شده است",
  NotValidFrom: "زمان شروع معتبر نمی باشد",
  NotHistoryActive: "این گروه دارای دوره فعال نمی باشد",
  ExistOldFactor: "فاکتور مورد نظر در دوره فعال می باشد",
  NotEqualRequestWithData:
    "این تعداد کاربر درخواستی از تعداد کاربر فعال دوره قبلی کمتر می باشد",
  TicketSupport: "لطفا این مورد را برای بخش پشتیبانی تیکت بزنید",
  TicketClosed:
    "این تیکت به دلیل اتمام پروسه بسته شد.\r\nدر صورت وجود مشکل یا ابهام جدید می‌توانید تیکت جدیدی ثبت کنید.\r\n                                 ",
  Thickness99: "پشتیبانی سایز تیغه ،99 میلیمتر می باشد",
  NotAccessLimit:
    "دسترسی لازم برای انجام این عملیات، برای شما وجود ندارد ( محدودیت  )",
  Area99: "پشتیبانی مساحت ،99 مترمربع می باشد",
  MaxPieceNotEqualBranch:
    "سایز قطعه پروفیل همراه با تیغه برش، بزرگتر از طول شاخه پروفیل می باشد",
  NotExistUserAgent: "فقط کاربران نماینده به این سامانه دسترسی دارند",
  ChangePhoneNumberTwoFactor:
    "همزمان نمیتوان شماره موبایل و ورود دو مرحله ای تغییر داد",
  InValidPhone: "شماره موبایل نا معتبر می باشد",
  InValidCity: "شهر نا معتبر می باشد",
  UniqueNameRepeated: "نام انحصاری تکراری می باشد",
  InValidRepresentative: "کد معرف نامعتبر می باشد",
  InvalidToken: "توکن نامعتبر می باشد",
  InValidEmail: "ایمیل نامعتبر می باشد",
  DuplicatePhoneNumber: "شماره موبایل تکراری می باشد",
  DuplicateEmail: "ایمیل تکراری می باشد",
  AvataSize70: "حجم آواتار باید کمتر از هفتاد کیلوبایت باشد",
  PasswordError: "رمز کاربر صحیح نمی باشد",
  AvatarERROR: "در ذخیره سازی تصویر کاربر اشکالی ایجاد شده است",
  PhoneNumberConfirmed: "شماره موبایل تایید نشده است",
  GiftCardNotValid: "کد کارت هدیه نا معتبر می باشد",
  GiftCardTime: "این کارت هدیه در محدوده زمانی مقرر نمی باشد",
  GiftCardUsed: "این کارت هدیه قبلاً  استفاده شده است",
  GiftCardTypePeriod: "این کارت هدیه مخصوص افزایش بازه زمانی می باشد",
  DistCardNotValid: "کد کارت تخفیف نا معتبر می باشد",
  DistCardMinSale: "برای فعال سازی این کارت  تخفیف حداقل خرید",
  DistCardTime: "این کارت تخفیف در محدوده زمانی مقرر نمی باشد",
  DistCardUsed: "این کارت تخفیف قبلاً استفاده شده است",
  DistCardFactorSpecial:
    "این کارت تخفیف مخصوص فاکتوری می باشد که در لیست موجود نمی باشد",
  DistCardLimitSpecial:
    "این کارت تخفیف مخصوص ماژولی می باشد که در لیست موجود نمی باشد",
  DistCardProductSpecial:
    "این کارت تخفیف مخصوص محصولی می باشد که در لیست موجود نمی باشد",
  CountProductMin: "حداقل یک محصول نیاز هست",
  CountLimitMin: "حداقل ماژول های لازم نیاز می باشد",
  StandardCountSuperVisor:
    "تعداد استاندارد کاربر ناظر نسبت به کاربران رعایت نشده است",
  CountFactorMin: "حداقل یک فاکتور نیاز هست",
  GiftCardMinCount: "این کارت هدیه جشنواره ای می باشد",
  NotExistUserGuest: "فقط کاربران مهمان به این سامانه دسترسی دارند",
  FactorSysSave: "بخاطر ساختار این گزارش، قادر به ذخیره سازی نمی باشید",
  InvalidCaptcha: "کپچا نا معتبر می باشد",
  Unitfailure:
    "متاسفانه در مراحل ذخیره سازی مشکلی پیش آمده است و لطفا این یونیت را حذف و مجددا طراحی نمایید",
  AccessUserFactor:
    "متاسفانه برای ثبت دسترسی کاربر به فاکتور،برنامه با مشکل مواجه شده است. لطفا با پشتیبانی نرم افزار تماس حاصل فرمایید",
  AdminUseGroup: "برای این گروه قبلاً کاربر ادمین ثبت شده است",
  CountPopSysMin:
    "با توجه به لزوم تعریف و فعال بودن حداقل یک بازشو در هر یک از سیستم های بازشو، قادر به حذف این بازشو نمی باشید",
  Exeptionsupport:
    "متاسفانه برنامه با مشکل مواجه شده است. لطفا با پشتیبانی نرم افزار تماس حاصل فرمایید",
  KeyNotCompany: "کد شرکت صحیح نمی باشد",
  KeyNotUser: "کد کاربر صحیح نمی باشد",
  SystemId: "کد سیستمی می باشد",
  AccessUserCenter: "متاسفانه قادر به تعریف و اضافه کردن کاربر نمی باشید",
  KeyNotUserRgister: "کاربری با این مشخصات در این گروه یافت نشد",
  LockedOut:
    "بدلایل فنی و امنیتی، لطفا 10 دقیقه دیگر درخواست خود را مجددا امتحان نمایید",
  InvalidMobile: "شماره تلفن وارد شده مورد تایید نمی باشد",
  InvalidEmail: "آدرس ایمیل وارد شده مورد تایید نمی باشد",
  NotGenerateCode: "خطا در اعتبارسنجی",
  ConfrimEmailOld: "این ایمیل قبلاً تایید شده است",
  ConfrimMobileOld: "این شماره همراه قبلاً تایید شده است.",
  SendTempEmail: "کد مورد نظر در صورت صحت ایمیل ارسال خواهد شد",
  SendTempMobile: "کد مورد نظر در صورت صحت شماره همراه ارسال خواهد شد",
  NotDeleteCompany: "به علت تعریف گروه برای این شرکت، امکان حذف آن نمی باشد",
  ExistNameOld: "با این نام قبلاً ثبت شده است",
  NotExist: "اطلاعات مورد نظر یافت نشد",
  NotAccess: "دسترسی لازم برای انجام این عملیات، برای شما وجود ندارد",
  InsertError: "خطایی در زمان ثبت اطلاعات بوجود آمده است",
  UpdateError: "خطایی در زمان ویرایش اطلاعات بوجود آمده است",
  RelationDelete:
    "به علت استفاده از این اطلاعات در بخشی از برنامه، امکان حذف آن نمی باشد",
  DeleteError: "خطایی در زمان حذف اطلاعات بوجود آمده است",
  NotUpdateField: "امکان ویرایش این فیلد سیستمی نمی باشید",
  NotAccessUserRecordAdmin:
    "تغییر اطلاعات رکورد گروه، توسط کاربران امکان پذیر نمی باشد",
  NotAccessAdminUserRecord:
    "تغییر اطلاعات رکورد کاربر، توسط ادمین امکان پذیر نمی باشد",
  SelectError: "خطایی در زمان فراخوانی اطلاعات بوجود آمده است",
  ErrorRegister: "خطایی در زمان ذخیره سازی، سطح دسترسی کاربران بوجود آمده است",
  RepeatOrder: "اولویت مشخص شده تکراری می باشد",
  NotRegisterState: "لطفا وضعیت پروژه را مشخص نمایید",
  IsLockUnit: "این یونیت در وضعیت غیر قابل تغییر می باشد",
  NotRelation: "ارتباطی برای این آیتم پیدا نشده است",
  NotRelationForDisable:
    "با توجه به عدم استفاده از این آیتم در هیچ قسمت برنامه، لازم است از گزینه حذف استفاده نمایید",
  CrossRange: "تداخل در محدوده های قبلی بازشو بوجود آمده است",
  AvataSize: "سایز تصویر کاربر وارد شده معتبر نمی باشد",
  ExistUserMobile: "کاربری با این شماره تماس قبلاً ثبت شده است",
  ExistUserMobileAdmin:
    "کاربری در نقش ادمین، بااین شماره تماس قبلاً ثبت نام شده است",
  ExistUserEmailAdmin: "کاربری در نقش ادمین، بااین ایمیل قبلاً ثبت نام شده است",
  SuffixEmailBlocked: "این ایمیل معتبر نمی باشد",
  ExistUserRegister: "کاربری با این نام کاربری قبلاً ثبت شده است",
  ExistUserEmail: "کاربری با این ایمیل قبلاً ثبت شده است",
  BlockUser: "کاربر غیر فعال می باشد",
  ParameterSelect: "لطفا پارامترهای مورد نظر را انتخاب نمائید",
  OneUnit: "حداقل یک یونیت انتخاب شود",
  ExistOld: "با این مشخصات قبلاً ثبت شده است",
  InvalidUser: "اطلاعات وارد شده معتبر نمی باشد",
  ConcurrencyFailure: "خرابی همزمانی خوشبینانه، شی اصلاح شده است",
  InvalidKey: "کد وارد شده صحیح نمی باشد",

  API_ERR_WrongData: "اطلاعات ارسالی را بررسی کنید",
  API_ERR_NoInternet: "لطفا اینترنت خود را بررسی کنید",
  API_ERR_SomeError: "خطایی رخ داده است.",
  API_ERR_ManyReqInSec: "تعداد درخواست بیش از حالت مجاز می‌باشد",
  API_ERR_ServerErr: "خطایی در سرور رخ داده است.",

  //! -> [IMPORT] Design-Messages
  AccordionDoesNotFit: "آکاردئونی در این مکان قرار نمی گیرد",
  ValueNotValid: "مقدار وارد شده معتبر نمی باشد",
  TypeFrameSlidingMullionNotPlace:
    "نوع فریم کشویی هست و مولیون در آن قرار نمی گیرد",
  DoseNotIniscriptionMullion:
    "دسته پروفیل جاری در این سیستم دارای مولیون کتیبه نمی باشد",
  FirstCleanMullions: "ابتدا مولیون ها را پاک کرده سپس کوپل بزنید",
  FirstSelectRailModel: "ابتدا مدل ریلی را نتخاب کنید",
  DividerNotFit: "تقسیم کننده در این مکان قرار نمی گیرد",
  TypeFrameOpening: "نوع فریم لولایی هست و سیستم کشویی در آن قرار نمی گیرد",
  TechnicallyCheck: "از نظر فنی چک شود",
  NotPossibleToPlace: "امکان قرار گیری وجود ندارد",
  IsNotPossibleSlidingSystem:
    "امکان قرار دادن سیستم کشویی در این قسمت وجود ندارد",
  NotPossibleMoveCouple: "به علت وجود مولیون امکان جابه جایی کوپل نیست",
  EqualGlassDoesNotWork: "شیشه مساوی در این وضعیت عمل نمی کند",
  NotPossibleRiser: "امکان قرارگیری ارتفاع دهنده در این وضعیت نیست",
  SaveUnitErrorGlass:"در اطلاعات شیشه‌های این یونیت خطایی وجود دارد. لطفا شیشه‌ها را بررسی کنید یا یونیت را مجدداً طراحی نمایید",
  HeightNotCorrect: "رتفاع وارد شده صحیح نیست",
  HeightEnteredLessSizeThreshold:
    "ارتفاع وارد شده از سطح زمین کمتر از سایز آستانه می باشد. لطفا مقدار وارد شده را اصلاح نمایید",
  ThresholdIsNotPlace: "آستانه در این وضعیت قرار نمی گیرد",
  NotAppliedPresenceHeightMullions:
    "به علت وجود مولیون کاهش ارتفاع اعمال نمی شود",
  AstanaPrerequisiteIsSashProfile:
    "به علت عدم وجود سش آستانه در این یونیت قرار نمی گیرد",
  ThreSholdChangeOperation: "عملیات تغییر آستانه یونیت با موفقیت انجام گردید",
  MullionIsNotPlace: "در این مکان مولیون قرار نمی گیرد",
  PartIsNotPlace: "قطعه در مکان مناسبی قرار ندارد",
  NotBeChosen: "محل مناسبی انتخاب نشده است",
  FittingIsNotDefine:
    "امکان قرار دادن این بازشو به علت تعریف نشدن یراق وجود ندارد",
  NotValidClickModelRail: "این مدل کشویی قابل پیاده سازی نمی باشد",
  ProfileIsNotDefine:
    "به علت تعریف نشدن دسته پروفیل مربوط این سیستم قابل پیاده سازی نمی باشد",
  NotChangeFrameInCombinedSystem: "در سیستم ترکیبی امکان تغییر فریم نمی باشد",
  PresenceCouplerNotConvert:
    "به علت وجود کوپل امکان تبدیل فریم به فریم بازسازی و فریم مولیون وفریم سش نمی باشد",
  CouplerMinimumDistance:
    "کوپل باید حداقل فاصله مجاز را از بقیه اجزا داشته باشد",
  CoupleDoesNotFail: "کوپل در شکست قرار نمی گیرد",
  CoupleDoesNotFitPlace: "کوپل انتخاب شده در این مکان قرار نمی گیرد",
  MullionDoesNotFitPlace: "مولیون انتخاب شده در این مکان قرار نمی گیرد",
  MullionDoesNotFail: "مولیون در شکست قرار نمی گیرد",
  MullionMinimumDistance:
    "مولیون باید حداقل فاصله مجاز را از بقیه اجزا داشته باشد",
  SmallSizeSashNotPlace: "به علت کوچک بودن قطعه سش قرار نمی گیرد",
  IntersectionLines: "خطا در تقاطع خطوط",
  NotPossibleMakeCoupleInSashFrame:
    "در فریم بازسازی و فریم سش و فریم مولیون امکان زدن کوپل وجود ندارد",
  MullionInscriptionNotPlace: "مولیون کتیبه در این مکان قرار نمی گیرد",
  OpeningIsNotDefinedBrandFitting:
    "این بازشو در برند یراق انتخاب شده تعریف نشده است",
  VolksWagenDoesNotPlace: "فولکس واگن در این مکان قرار نمی گیرد",
  PivotDoesNotPlace: "محوری در این مکان قرار نمی گیرد",
  SashDoesNotPlace: "سش در این مکان قرار نمی گیرد",
  FaransaviNotPlace: "فرانسوی در این مکان قرار نمی گیرد",
  PresenceThreSholdOpeningDoesNotPlace:
    "به علت وجود آستانه بازشو در این مکان قرار نمی گیرد",
  OpeningDoesNotPlace: "بازشو در این مــکان قرار نمی گیرد",
  OpeningStandard: "قرار دادن این بازشو در الگو فعلی استاندارد نیست",
  FirstCleanInternlalParts: "ابتدا قطعات داخلی را پاک کنید",
  SmallSizeOpeningNotPlace: "به علت کوچک بودن قطعات بازشو قرار نمی گیرد",
  SystemRailOneCouple:
    "در این سیستم کشویی فقط میتوانید یک  اتصال استفاده نمائید",

  // ! ## ## ## ## ## ## ## ## ## ## ## ## Super-Admin-Menu-Items ## ## ## ## ## ##
  sami_pricing: "قیمت دهی",
  sami_support: "پشتیبانی",
  sami_tickets: "تیکت‌ها",
  sami_notices: "اطلاعیه‌ها",
  sami_financial: "مالی",
  sami_tools: "ابزارهای ویژه",
  sami_statistics: "آمار",
  customerslist: "لیست مشتریان",
  customerName: "نام مشتری",
  limits: "محدودیت ها",
  usersList: "لیست کاربران",
  periods: "دوره ها",
  period_details: "جزئیات دوره",
  infos: "اطلاعات کاربر",
  details: "جزئیات",
  payByCredit: "پرداخت با کیف پول",
  changeAdminStatus: "ثبت فعال/غیرفعال کردن سوپر ادمین",
  addMoreUser: "اضافه کردن کاربر جدید",
  products: "محصولات",
  supervisor: "کاربر ناظر",
  maxDiscount: "حداکثر مبلغ تخفیف",
  percentageDiscount: "تخفیف درصدی",
  stepDiscount: "تخفیف پله‌ای",
  dayCount: "تعداد روز",
  order: "اولویت",
  isActive: "فعال/غیر‌فعال",
  isDefault: "پیش فرض/غیر‌پیش فرض",
  transactions: "تراکنش های مالی",
  defaultPanel: "پنل پیش فرض",
  defaultCharges: "شارژ پیش فرض",
  doFilter: "اعمال فیلتر",
  productCount: "تعداد محصول",
  priceCredit: "اعتبار",
  discountCard: "کارت تخفیف",
  discountCode: "کد تخفیف",
  incTime: "افزایش زمان",
  incCredit: "شارژ کیف پول",
  discountValue: "مقدار تخفیف",
  minDiscountUsage: "حداقل مبلغ خرید",
  usageCount: "دفعات قابل استفاده",
  refrence: "آیتم اختصاصی",
  stype: "نوع استفاده",
  newIncTime: "افزودن زمان به دوره",
  newIncCredit: "افزایش شارژ کیف پول",
  stagroup: "گروهی از کاربران",
  noData4Send: "اطلاعاتی برای ارسال وجود ندارد",
  info_userAccountInfo: "اطلاعات حساب",
  info_userAccountRemain: "زمان باقیمانده از سرویس",
  info_countUser: "تعداد کاربر",
  info_credit: "اعتبار",
  info_jalaliDate: "تاریخ",
  info_jalaliDay: "روز",
  info_period: "دوره خریداری شده",
  info_show: "وضعیت فعلی",
  info_show_Extension: "امکان تمدید دوره جاری",
  info_show_Sale: "امکان خرید",
  info_show_Upgrade: "امکان افزایش کاربر",
  info_Years: "سال",
  info_Months: "ماه",
  info_Days: "روز",
  info_RemainDays: "روز تا پایان اشتراک",
  info_Hours: "ساعت",
  info_Minutes: "دقیقه",
  info_Seconds: "ثانیه",
  info_MilliCalc: "میلی ثانیه",
  enterDashboard: "ورود به داشبورد کاربر",
  enterDashboardError: "انتقال به داشبورد در حال حاضر فعال می‌باشد",
  disabledTransport: "خروج از داشبورد کاربر",
  sapg_periodsDetail: "جزئیات دوره",
  sapg_periodsCharge: "شارژها",
  sapg_periodsPay: "پرداخت‌ها",
  sapd_payType: "نوع پرداخت",
  periodDetailDiscount: "تخفیف",
  discountModel: "نوع تخفیف",
  satpa_num1: "خرید",
  satpa_num2: "ارتقا",
  satpa_num3: "رایگان",
  satp_num1: "کیف پول",
  satp_num2: "درگاه بانک",
  role: "نقش",
  IsActiveWithAdminPermisson: "وضعیت(ادمین)",
  IsDisableWithSuperAdminPermisson: "وضعیت(سوپرادمین)",
  normalUserCount: "تعداد کاربر عادی",
  nazerUserCount: "تعداد کاربر ناظر",
  isCalculate: "در حال محاسبه",
  noDataInIncreaseUser: "لطفا یکی از مقادیر کاربران را وارد نمایید",
  userIncreaseDetails: "جزئیات افزایش کاربر",
  userIncreaseDetailPriceShow: "قابل پرداخت",
  userIncreaseDetailDiscount: "تخفیف",
  saiu_Limit: "خدمت",
  saiu_SuperVisor: "کاربر ناظر",
  saiu_Factor: "فاکتور",
  saiu_Product: "کاربر",
  change_user_active:
    'از تغییر وضعیت کاربر "@USERNAME"از "@NOW"به "@UPDATE"اطمینان دارید ؟',
  sali_Name: "نام محدودیت",
  sali_BuyCount: "تعداد خریداری شده",
  sali_UsedCount: "تعداد استفاده شده",
  sali_RequestCount: "تعداد درخواستی",
  limitsIncreaseDetails: "جزئیات افزایش محدودیت‌ها",
  noDataInIncreaseLimits: "لطفا حداقل یکی از مقادیر محدودیت ها را وارد نمایید",
  safa_IsActive: "فعال در دوره",
  safa_IsRequest: "فعال شود",
  noDataInIncreaseFactors: "فاکتوری برای فعال سازی انتخاب نشده است",
  factorsIncreaseDetails: "جزئیات افزایش فاکتور‌ها",
  supervisorTblName: "قیمت کاربر ناظر",
  chooseOnePeriod: "یک دوره را انتخاب کنید",
  addNewSupervisor: "قیمت کاربر ناظر جدید",
  editSupervisor: "ویرایش قیمت کاربر ناظر",
  deleteSupervisor: "حذف قیمت کاربر ناظر",
  serviceTblName: "قیمت سرویس‌ها",
  chooseOneService: "یک سرویس را انتخاب کنید",
  serviceName: "نام سرویس",
  addPriceService: "سرویس قیمت جدید",
  editPriceService: "ویرایش سرویس قیمت",
  deletePriceService: "حذف سرویس قیمت",
  productTblName: "قیمت محصولات",
  chooseOneProduct: "یک محصول را انتخاب کنید",
  productName: "نام محصول",
  minCount: "حداقل",
  maxCount: "حداکثر",
  addPriceProduct: "قیمت محصول جدید",
  editPriceProduct: "ویرایش قیمت محصول",
  deletePriceProduct: "حذف قیمت محصول",
  MinCount_EQ_MaxCount: "مقدار حداکثر از مقدار حداقل باید بیشتر باشد",
  factorTblName: "قیمت فاکتورها",
  chooseOneFactor: "یک فاکتور را انتخاب کنید",
  factorName: "نام فاکتور",
  addPriceFactor: "قیمت فاکتور جدید",
  editPriceFactor: "ویرایش قیمت فاکتور",
  deletePriceFactor: "حذف قیمت فاکتور",
  periodTblName: "قیمت دوره‌ها",
  addPricePeriod: "قیمت دوره جدید",
  editPricePeriod: "ویرایش قیمت دوره",
  deletePricePeriod: "حذف قیمت دوره",
  isActivePeriod: "دوره فعال",
  transactionsTblName: "لیست تراکنش‌ها",
  chooseOneGroup: "یک گروه را انتخاب کنید",
  checkDate: "تاریخ شروع و پایان فیلتر را به درستی وارد کنید",
  groups: "گروه‌ها",
  saaf_JalaliDate: "تاریخ",
  saaf_Type: "نوع",
  saaf_Sale: "فروش",
  saaf_Credit: "اعتبار",
  defaultPanelTblName: "لیست پنل‌های پیش فرض",
  safd_Name: "نام پنل",
  addDefaultPanel: "پنل پیش فرض جدید",
  editDefaultPanel: "ویرایش پنل پیش فرض",
  deleteDefaultPanel: "حذف پنل پیش فرض",
  defaultChargeTblName: "لیست شارژ‌های پیش فرض",
  addDefaultCharge: "شارژ پیش‌ فرض جدید",
  editDefaultCharge: "ویرایش شارژ پیش فرض",
  deleteDefaultCharge: "حذف شارژ پیش فرض",
  discountCardTblName: "لیست کارت‌های تخفیف",
  addDiscountCard: "کارت‌ تخفیف جدید",
  editDiscountCard: "ویرایش کارت‌ تخفیف",
  deleteDiscountCard: "حذف کارت‌ تخفیف",
  sadc_Stype: "نوع",
  sadc_Refrence: "آیتم",
  sadc_MinBuy: "حداقل مقدار خرید",
  sadc_UsableCount: "تعداد قابل استفاده",
  sadc_CountUsed: "استفاده شده",
  incTimeTblName: "لیست افزایش زمان‌ها",
  sati_UserRegister: "کاربر ثبت شده",
  sati_Inc: "مقدار افزایش",
  sati_GroupId: "شناسه گروه",
  sati_ExpireJalali: "تاریخ انقضا",
  group_notice: "نوع اطلاعیه",
  post_type: "نوع ارسال",
  notice_reader: "افراد مجاز",
  notice_delete: "حذف اطلاعیه",
  notice_add: "اطلاعیه جدید",
  sati_IsFree: "وضعیت مالی",
  hoursNumber: "تعداد ساعت",
  freePeriod: "رایگان",
  nonFreePeriod: "غیر‌ رایگان",
  incCreditTblName: "لیست افزایش شارژ‌ها",
  satc_Method: "متود",
  satc_DateJalali: "تاریخ و زمان",
  satc_Isinc: "افزایشی",
  statisticTotalProject: "آمار کلی پروژه‌ها",
  statisticTotalYaragh: "آمار کلی یراق‌ها",
  statisticDaily: "آمار روزانه",
  removeFilter: "حذف فیلتر",
  changeProjects: "بازگشت به لیست پروژه‌ها",
  backToProjectList: "بازگشت به لیست پروژه‌ها",
  select_pattern: "لطفا الگو را انتخاب کنید",
  // technical_option: "با فعال کردن این گزینه محدودیت فنی در ابعادگیری در نظر گرفته نمیشود",
  technical_option: "حذف محدودیت فنی در ابعادگیری",
  default_settings: "تنظیمات پیش فرض",
  selected_pattern: "الگوی انتخاب شده",
  // ! ## ## ## ## ## ## ## ## ## ## ## ## SUPER-ADMIN ## ## ## ## ## ##
};

//! #-#-#   DELETED KEY   #-#-#
/*
  saaf_RetrivalRefNo: "شماره مرجع",
  saaf_SystemTraceNo: "شماره پیگیری",
  saaf_Price: "مبلغ",
  saaf_Group: "گروه",
  saaf_Order: "شماره فاکتور",
  saaf_Describ: "توضیحات",
  satc_Type: "روش",
  

  lolayi: "لولایی",
  keshoyi: "کشویی",
  NotValid: "اطلاعات وارد شده معتبر نمی باشد",
  InvalidUser: "اطلاعات وارد شده معتبر نمی باشد",
  ExistOld: "با این مشخصات قبلاً ثبت شده است",
  RepeateRecordUpdate: "با این مشخصات قبلاً ثبت شده است",
  InvalidKey: "کد وارد شده صحیح نمی باشد",
  InvalidCode: "کد وارد شده صحیح نمی باشد",
  LockProject: "پروژه در وضعیت قفل می باشد",
  behinehSazi: "بهینه سازی",
  statisticUnit: "یونیت",
  statisticProject: "پروژه",
  statisticTotal: "آمار کلی",
  statotal: "کلیه سیستم",
  naghsh: "نقش",
  ersaleCode: "ارسال کد",
  pakhor: "پاخور",
  astane: "آستانه",
  khadamat: "خدمات",
  Template: "الگو",
  optimal : "بهینه سازی",
  sizeRokub: "سایز",
  fommastic: "فوم و ماستیک",
  err_emptyData: "اطلاعاتی برای نمایش وجود ندارد",
  header_enter_your_contact_number: "لطفا شماره تلفن همراه خود را وارد کنید",
  Statistics: "آمار",
  _freePeriod: "دوره رایگان",
  _price: "مبلغ",
  describe: "توضیحات",
  isDefaultPeriod: "پیش فرض",
  periodDetailPriceShow: "قابل پرداخت",
  sati_TimeRegister: "تاریخ و زمان",
  InvoiceTitle: "عنوان فاکتور",
  payment_successful: "پرداخت با موفقیت انجام شد",
  Price_edited_successfully: "قیمت با موفقیت ویرایش شد",
  the_price_was_edited_successfully: "ویرایش قیمت با موفقیت انجام شد",
  The_price_was_edited_successfully: "ویرایش قیمت با موفقیت انجام شد",
*/
